import { Component, Input, OnInit, OnDestroy, OnChanges, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService, CalculationService, FormatService, DateService } from 'app/services';
import { config, messages, tireTypeSuggestions } from 'app/constants';
import { UpdateCannedServiceDialogComponent } from '../update-canned-service-dialog/update-canned-service-dialog.component';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { currency } from 'app/constants/currency.constants';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

import { find, debounce, findIndex, trim, lowerCase } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { WarrantyEligibleDialogComponent } from 'app/modules/estimate/components';
import { datetimeFormat } from 'app/constants/date-time-format';
import { title } from 'process';
import { QtyOnEstimateListModalComponent } from '../qty-on-estimate-list-modal/qty-on-estimate-list-modal.component';
import { PartsPricingDialogComponent } from 'app/modules/settings/modules/pricing/parts-pricing/parts-pricing-dialog/parts-pricing-dialog.component';

@Component({
  selector: 'app-new-tire-add',
  templateUrl: './new-tire-add.component.html',
  styleUrls: ['./new-tire-add.component.scss'],
})
export class TireAddNewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() customerId: string = '';
  @Input() vehicleId: string = '';
  // @Input() brands: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() locations: any[] = [];
  @Input() tagsSuggestion: any[] = [];
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() pricingRules: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() tireId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() isOpenFromMO: boolean = false;
  @Input() orderId: string = '';
  @Input() isTaxable: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() poDetails: any = {};
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() openFrom: string = '';
  @Input() serviceItem: any = {};
  @Input() customerInfo: any = {};
  @Input() averageCost: number = 0;
  @Input() latestPoCost: number = 0;
  @Input() defaultTaxable: boolean = false;
  @Input() isAutoLeapItem: boolean = false;
  @Input() isPartsTechItem: boolean = false;
  @Input() itemResults: any[] = [[]];
  @Input() isSearching: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isFeeAssociationEnabled: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isMarkAsInventoryEnabled: boolean = false;
  @Input() categories: any[] = [];
  @Input() categoryType: string = '';
  @Input() isOnlineInvOrderEnabled: boolean = false;
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() isOpenFromST: boolean = false;
  @Input() isQTQAddOnEnable: boolean = false;
  @Input() isPassThroughTaxEnable: boolean = false;
  @Input() isTireConnectConnected: boolean = false;
  @Input() canEditClassifications: boolean = false;
  @Input() isSalesCodeEnabled: boolean = false;
  @Input() cardGroupIndex: number = -1;
  @Input() isForceLocationUpdate: boolean = false;
  @Input() invoicedRO: boolean = false;
  @ViewChild('contentContainer') contentContainer!: ElementRef;
  sections = [
    { title: 'Basic Information' },
    { title: 'Seasonality' },
    { title: 'Pricing' },
    { title: 'Part Classification' },
    { title: 'Inventory Details' },
    { title: 'Tire Settings' },
    { title: 'Additional Details' },
  ];
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  activeIndex: number = 0;
  selectedTab: number = 0;
  hazmatFeeObject: any = {};
  defaultSizeObject = {
    size: '',
    code: '',
    cost: '',
    count: 4, // adding default quantity against ticket ALP-17370
    pricingMatrix: null,
    price: '',
    isTaxable: true,
    status: true,
    displayDescOnOrder: true,
    displayHoursOnOrder: true,
    commissionable: true,
    hazmatFeeArray: [{}],
  };
  tire: any = {
    brand: null,
    model: '',
    vendor: null,
    seasonality: '',
    stocked: false,
    sizes: [],
    errors: [],
    category: { name: '' },
    locationQboItemRefId: {},
    isChangeInPriceMatrix: false,
    whichPricingMatrixUsed: '',
    tireSize: '',
    tireProfile: '',
    tireWidth: '',
    tireSizeSearch: '',
    warranty: {},
    fet: null
  };
  usd: string = currency.USD;
  defaultActiveState: boolean = true;
  vendorsSuggestion: any[] = [];
  isProcessing: boolean = false;
  isAssigningFET: boolean = false;
  errors: any = {};
  defaultQboItemRefs: any[] = [];
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);
  private unsubscribe: Subject<boolean> = new Subject<boolean>();
  isCannedServiceFieldsUpdated: boolean = false;
  updateGenericItem: boolean = false;
  focus: any = {};
  // used to maintain state changes for each component
  initalInputStates = <any>{};
  updatedInputStates = <any>{};
  categoryResults: any[] = [];
  companyRule: any = {} // For Company level Rule (Pricing matrix)
  config: any = config;
  categoryName: any = '';
  isShowError: boolean = false;
  categorId: any = '';
  pricingMatrixList: any[] = [];
  noMatrix: any[] = [];
  isChangeInPriceMatrix: boolean = false;
  whichPricingMatrixUsed: any = '';
  isMultiLocationEnabled: boolean = false;
  isNewCategoriesEnabled: boolean = true;
  currentShopId: string = '';
  activityLogs: any[] = [];
  filterOptionModel = {
    itemHistory: false,
    purchaseHistory: false,
    sellingHistory: false,
    pricingHistory: false,
  };
  filterOption: any[] = [];
  isFilterLoading: boolean = false;
  selectedFilterOptionLength: number;
  customCategory: any = {};
  tireTypeSuggestion: any[] = [];
  defaultTireTypeSuggestion = tireTypeSuggestions;
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  showLoaderTireconnect: boolean = false;
  calculatedAmount: number = 0;
  isAddedManually = false;
  locationsResults: any[] = [];
  pricingMatrixResults: any[] = [];
  tableConfig = {
    offset: 0,
    limit: config.pageSize,
    sortField: 'title',
    sortOrder: 1,
    search: '',
  };
  costOptions: any[] = [{ label: 'Cost', value: 'cost' }];
  defaultCostOptions: any = [
    { label: 'Cost', value: 'cost' },
    { label: 'Avg. Cost', value: 'avg' },
    { label: 'Latest PO', value: 'latestPo' },
  ];
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  isBrandLoading: boolean = false;
  hasMoreData = true;
  offset = 0;
  limit = 27;
  searchQuery = '';
  brands = [];
  isFirstTimeLoad = true;
  partsTechPageIndex: number = 0;
  partstechResults: any = [];
  partSearchResults: any = [];
  isDataLoading: boolean = false;
  totalRecords: number = 0;
  isShowPartSuggestions: boolean = false;
  isProcessingResults: boolean = false;
  isMagicFocus: boolean = false;
  partstechSuggestions: any = [];
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;
  selectedType: any = '';
  isPartWarrantiesEnabled: boolean = false;
  isUseOnlinePricing: boolean = false;
  isFocusPartTire: boolean = false;
  isFetchingWarranty: boolean = false;
  initialData: any = {};
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  tooltipData: any = {};
  tooltip: any = '';
  isExpanded = true;
  utgq: any = {};
  transferOptions: any[] = [
    { label: 'Receive item via transfer', value: 'receiver' },
    { label: 'Send item via transfer', value: 'sender' },
  ];
  warehouses: any[] = [];
  partStockDetails: any[] = [];
  isStockTransferEnabled: boolean = false;
  feeServiceItems: any[] = [];

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public formatService: FormatService,
    private dynamicDialogRef: DynamicDialogRef,
    private calculationService: CalculationService,
    private dataService: DataService,
    private dialogService: DialogService,
    private dateService: DateService
  ) { }

  ngOnInit() {
    if (!this.tireId) {
      this.focus = { tireExternalId: true };
    }
    this.noMatrix = [
      ...(!this.isAttributeBasedPricingEnable ? [{}] : [{
        name: 'No pricing rules',
      }]),
    ];
    this.getLocalizationFlags();

    this.updateActiveIndex(0);
    this.setClickOutSideListeners();
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
    this.getTireTypes();
    if (this.tireId) {
      this.getLogs();
    }

    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
    this.isUseOnlinePricing = this.dataService.isUseOnlinePricing || false;
    this.isStockTransferEnabled = this.dataService.isStockTransferEnabled;
    this.isMultiLocationEnabled = this.helperService.getCompany()?.isMultiLocationEnabled;

    if (this.isStockTransferEnabled && this.isMultiLocationEnabled) {
      this.getWarehouses();
    }

  }


  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  handleTransferSelect(event: any) {
    this.item.transferedVia = event?.value;
    this.createTransferOrderWithItems([this.item]);
  }

  createTransferOrderWithItems(itemsList: any[]) {
    this.httpService
      .createTransferStockOrder(itemsList)
      .then((res) => {
        if (res) {
          try {
            this.helperService.openPageInNewTab(`${config.redirectUrl.transferStock}/${res._id}`);
          } catch (error) {
            this.helperService.showToaster('error', error);
          }
        }
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      });
  }

  getTireTypes() {
    this.tireTypeSuggestion = this.helperService.deepCopy(
      this.defaultTireTypeSuggestion.map((tire: any) => {
        return {
          name: tire.name,
          tireTypeId: tire.tireTypeId,
          _id: tire.tireTypeId,
          isCommercial: tire.isCommercial,
        };
      }),
    );
    this.defaultTireTypeSuggestion = this.helperService.deepCopy(this.tireTypeSuggestion);
  }

  ngOnChanges(change: any) {
    const { pricings = [], isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.tireId) {
          this.defaultTaxable = this.isTaxable;
          this.defaultSizeObject.isTaxable = this.isTaxable;
          this.tire.sizes.forEach((tire: any) => {
            tire.isTaxable = this.isTaxable;

            if (this.isMarkAsInventoryEnabled) {
              tire.hasMarkedInventory = this.isOpenFromPO || this.openFrom === 'inventoryAdd';
            }
          });
        }
        this.currentShopId = localStorage.getItem('currentShop') || this.helperService.getCurrentShopId();
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
        this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
        this.isUseOnlinePricing = this.dataService.isUseOnlinePricing || false;

        if (this.isPartWarrantiesEnabled) {
          if (this.isPartWarrantiesEnabled && !find(this.sections, { field: 'Tire Warranty' })) {
            const index = findIndex(this.sections, { title: 'Inventory Details' });

            this.sections.splice(index + 1, 0, { title: 'Tire Warranty' });
          }
        }
        this.getLocations();
        this.searchQuery =
          this.poDetails?.onlineItem?.brand?.brandName ||
          this.poDetails?.onlineItem?.brand ||
          this.serviceItem?.brand?.brandName ||
          this.serviceItem?.brand?.name ||
          this.serviceItem?.brand ||
          this.item?.brand?.brandName ||
          this.item?.brandName ||
          this.item?.brand;

        if (this.isNewItemCategoriesEnable && !this.isPartsTechItem) {
          this.getBrands();
          this.getAllCategories();
        } else {
          this.setCategories(this.categories);
          this.setBrands(this.tagsSuggestion);
        }
        this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
        this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);

        this.setSuppliers(this.suppliers);
        this.setItemDetails(this.item);
        //adding the check for the purchase order opening ALP-19787
        if (!this.tire?.stocked && this.isOpenFromRO && !this.isOpenFromPO) {
          this.sections = this.sections.filter(({ title }) => title !== 'Inventory Details');
        }
        this.isProcessing = false;
      }
    }
    if (pricings.previousValue && pricings.currentValue) {
      if (!pricings.previousValue.length && pricings.currentValue.length) {
        if (this.isAttributeBasedPricingEnable) {
          // override with pricing rules
          this.companyRule = this.helperService.deepCopy(find(this.pricingRules, {
            isCompanyLevelRule: true,
            itemType: 'tire'
          }))
        }
        this.pricingMatrixResults = this.helperService.deepCopy(this.pricings);
        this.calculatePrice(false);
      }
      this.setDefaultPricing()
      this.setPricingBasedOnAttributePricingFlag();
    }
  }
  setDefaultPricing() {
    if (this.isAttributeBasedPricingEnable) {
      let matrixInfo = this.helperService.deepCopy(this.pricingRules);
      this.setPricingMatrixForAttributeBasedPricing(matrixInfo);
      this.calculatePrice();
    } else {
      if (!(this.tire.sizes[0].pricingMatrix && this.tire.sizes[0].pricingMatrix?._id)) {
        for (let i = 0; i < this.pricings.length; i++) {
          if (this.pricings[i].default) {
            this.handleSizeChange('pricingMatrix', this.pricings[i]);
            break;
          }
        }
      }

    }
  }
  setBrands(tagSuggestions: any[]) {
    const brandArray = tagSuggestions?.map((item: any) => {
      item.categoryName = item?.name || '';
      return item;
    }) || [];
    this.brands = [...brandArray];
  }

  setCategories(categories: any[]) {
    const catArray = categories?.map((item: any) => {
      item.categoryName = item?.name || '';
      return item;
    }) || [];
    this.categoriesSuggestionsResults = [...catArray];
    this.categoryResults = [...catArray];
  }

  //function responsible for set up data globally in case of feature flag off
  setPricingBasedOnAttributePricingFlag() {
    if (!this.isAttributeBasedPricingEnable && !(this.isOpenFromPO || this.isOpenFromRO || this.isOpenFromST || this.openFrom === 'inventoryAdd')) {
      if (!this.item) {
        return;
      }
      //const price = this.tire.sizes[0].price;
      const price = this.tire.sizes[0].initialPrice;
      let pricingObj = find(this.pricingMatrixResults, { _id: this.item?.pricing?.pricingId?._id || this.item?.pricing?.pricingId });
      if (!pricingObj) {
        const shopDetail = find(this.item?.shopDetails, { shopId: this.helperService.getCurrentShopId() });
        if (shopDetail && shopDetail?.pricing?.pricingId) {
          pricingObj = find(this.pricingMatrixResults, { _id: shopDetail?.pricing?.pricingId });
        }
      }
      this.tire.sizes[0].pricingMatrix = pricingObj;
      this.calculatePrice();
      if (!pricingObj) {
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
        //if no pricing matric selected and has the calculated amount then reset that amount to show added manually
        if (this.calculatedAmount) {
          this.calculatedAmount = 0;
        }
        this.tire.sizes[0].price = price;
      }
    } else if (!this.isAttributeBasedPricingEnable && (this.isOpenFromPO || this.isOpenFromRO || this.isOpenFromST || this.openFrom === 'inventoryAdd')) {
      const pricingObj = find(this.pricingMatrixResults, { _id: this.serviceItem?.pricing?.pricingId?._id || this.serviceItem?.pricing?.pricingId });
      if (!Object.keys(pricingObj || {})?.length) {
        //if no pricing matric selected and has the calculated amount then reset that amount to show added manually
        if (this.calculatedAmount) {
          this.calculatedAmount = 0;
        }
      }
    }
  }

  scrollToContent(index: number): void {
    this.selectedTab = 0;
    setTimeout(() => {
      const element = document.getElementById(`content-${index}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        this.updateActiveIndex(index);
      }
    }, 50);
  }

  onScroll = debounce((event, n) => {
    const container = this.contentContainer.nativeElement;
    const sections = container.querySelectorAll('.sections-wrapper');
    const threshold = 100;
    sections.forEach((section: HTMLElement, index: number) => {
      const rect = section.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      if (index > 4) {
        if (rect.top >= containerRect.top && rect.bottom <= containerRect.bottom) {
          this.activeIndex = index;
        }
      } else {
        if (rect.top >= containerRect.top && rect.top <= containerRect.top + threshold) {
          this.activeIndex = index;
        }
      }
    });
  }, 500);

  updateActiveIndex(index: number): void {
    this.activeIndex = index;
  }

  // setCategories(categories: any[]) {
  //   this.categoryResults = [...categories];
  // }

  initializePricings() {
    if (!this.tireId) {
      this.setTireData();
    }
  }

  setSuppliers(suppliers: any[]) {
    this.vendorsSuggestion = [...suppliers];
  }

  setItemDetails(tire: any) {
    if (!this.tireId || !tire) {
      this.tire.sizes[0].commissionable = this.dataService.isCommissionTire;
      if (!tire?.costType) {
        this.tire.sizes[0].costType = 'cost';
      }
      this.setTireData(true);
      return;
    }

    this.tire = {
      errors: [],
      model: tire.model,
      seasonality: tire.seasonality,
      salesCode: tire.salesCode,
      qboId: tire.qboId,
      locationQboItemRefId: tire.locationQboItemRefId || {},
      stocked: tire.stocked,
      shopDetails: tire.shopDetails,
      isChangeInPriceMatrix: tire.isChangeInPriceMatrix,
      whichPricingMatrixUsed: tire.whichPricingMatrixUsed,
      tireWidth: tire.tireWidth,
      tireProfile: tire.tireProfile,
      tireSize: tire.tireSize,
      tireExternalId: tire?.tireExternalId || tire?.code || '',
      isWarrantyEligible: tire?.isWarrantyEligible || false,
      warranty: tire?.warranty || {},
      sizes: [
        {
          isTaxable: tire.isTaxable,
          status: tire.status,
          size: tire?.size,
          stocked: tire.stocked,
          count: Number(tire.count),
          title: tire.title,
          titleFR: tire.titleFR,
          tireID: this.tireId,
          code: tire.code,
          commissionable: tire.commissionable,
          restockLevel: tire.restockLevel,
          maxQuantity: tire.maxQuantity,
          cost: Number(tire.cost),
          initialDefaultCost: Number(tire.cost),
          price: Number(tire.price),
          description: tire.description,
          descriptionFR: tire.descriptionFR,
          internalNotes: tire.internalNotes,
          notes: tire.notes,
          // totalCost: Number(tire.cost) * Number(tire.count),
          totalPrice: Number(tire.price) * Number(tire.count),
          displayDescOnOrder: tire.displayDescOnOrder,
          displayHoursOnOrder: tire.displayHoursOnOrder,
          pricingMatrix: {},
          fetValue: tire?.fetValue || 0,
          shopDetails: tire?.shopDetails || [],
          initialPrice: Number(tire.price),
          previousTitle: `${this.tire?.brand?.name || ''} ${this?.tire?.model || ''} ${tire.size || ''}`,
        },
      ],
      loadIndex: tire?.loadIndex || '',
      loadIndexDual: tire?.loadIndexDual || '',
      speedRating: tire?.speedRating || '',
      loadRange: tire?.loadRange || '',
      sideWallStyle: tire?.sideWallStyle || '',
      utqg: tire?.utqg,
      mileageRating: this.processMiles(
        tire?.mileageRating
        || '')
    };

    if (tire.isMagicFill) {
      this.tooltipData = {
        magicFillBrand: tire.brand,
        magicFillCost: tire.magicFillCost,
        magicFillPrice: tire.magicFillPrice,
        magicFillDate: this.dateService.formatDate(new Date(tire.magicFillDate), datetimeFormat.hhmmaammmdyy),
      }
      this.setTooltipData();
    }

    if (tire.locations && tire.locations.length) {
      this.tire.sizes[0].location = tire.locations.pop();
    }

    if (!tire.costType) {
      this.tire.sizes[0].costType = 'cost';
      this.tire.sizes[0].cost = this.tire.sizes[0].costType === 'avg' ? this.averageCost : tire.fixedCost ? tire.fixedCost : tire.cost;
    } else {
      this.tire.sizes[0].costType = tire.costType;
      this.tire.sizes[0].cost = this.formatService.setDynamicCostAndPrice(tire, 'cost');
      this.tire.sizes[0].totalCost = Number(this.tire.sizes[0].cost) * Number(tire.count);
    }

    if (this.stock) {
      this.tire.sizes[0].qtyOnOrder = this.stock.countOnEstimate || 0;
      this.tire.sizes[0].qtyAvailable = this.stock.countAvailable || 0;
      this.tire.sizes[0].qtyOrdered = this.stock.countOrdered || 0;
      this.tire.sizes[0].qtyOnHand = this.stock.countInHand || 0;
    }

    if (this.isInventoryEnabled) {
      this.tire.hasMarkedInventory = tire.hasMarkedInventory;
      if (this.isMarkAsInventoryEnabled && !tire.hasMarkedInventory) {
        this.tire.sizes[0].hasMarkedInventory = this.isOpenFromPO || this.openFrom === 'inventoryAdd';
      }
    }

    if (this.tire?.stocked) {
      this.setStockedCostData(tire.costType, tire?.cost);
    }

    if (tire?.partSpecification) {
      this.tire.partSpecification = tire?.partSpecification;
    }

    if (tire.associatedItems) {
      let getElementFromArray = this.isOpenFromRO ? tire.associatedItems.map((itm) => {
        if (itm?.isPassThroughFet && itm?.type === 'hazmatFee') {
          itm.price = tire?.fetValue || 0;
        }
        //added itm?.itemId for the ALP-20572
        return (itm?.title || itm?.titleFR) ? itm : (itm?.itemId && (itm?.itemId?.title || itm?.itemId?.titleFR)) ? itm?.itemId : null;
      }).filter(itm => itm) : tire.associatedItems.map((itm) => {
        if (itm?.itemId?.isPassThroughFet && itm?.itemId?.type === 'hazmatFee') {
          itm.itemId.price = tire?.fetValue || 0;
        }
        return itm.itemId;
      });

      if (tire.associatedItems.length > 0) {
        this.tire.sizes[0].hazmatFeeArray = getElementFromArray;
      } else {
        this.tire.sizes[0].hazmatFeeArray = [{}];
      }
      this.feeServiceItems = this.tire.sizes[0].hazmatFeeArray;
    }

    this.defaultActiveState = tire.status;

    // For backward compatibility, if brandId exists use brand or else consider category as brand
    if (tire.brandId) {
      this.tire.brand = {
        _id: tire.brandId,
        BrandID: tire.brandId,
        name: tire.brand,
      };

      if (tire.category?.categoryId) {
        this.tire.category = {
          _id: tire.category.categoryId,
          BrandID: tire.category.categoryId,
          name: tire.category.name || tire.category.categoryName,
        };
      }
    }
    // else if (tire.category?.categoryId) {
    //   this.tire.brand = {
    //     _id: tire.category.categoryId,
    //     BrandID: tire.category.categoryId,
    //     name: tire.category.name || tire.category.categoryName,
    //   };
    // }
    else {
      this.tire.brand = {
        name: tire.brand,
      };
    }

    if (tire.category?.name || tire.category?.categoryName) {
      this.tire.category = {
        ...this.tire.category,
        name: tire.category.name || tire.category.categoryName,
        categoryName: tire.category.name || tire.category.categoryName,
      };
    }

    if (!Object.keys(this.tire.brand || {})?.length && this.brands?.length) {
      const tireBrand = this.brands[0];
      if (tireBrand) {
        this.tire.brand = tireBrand;
      }
    }

    if (tire.supplier && tire.supplier.name) {
      this.tire.vendor = {
        _id: tire.supplier.supplierId,
        name: tire.supplier.name,
      };
    }

    if (tire.pricing && tire.pricing.pricingId) {
      this.tire.sizes[0]['pricingMatrix'] = {
        _id: tire.pricing.pricingId._id,
        name: tire.pricing.pricingId.name,
      };
    } else {
      if (this.isAttributeBasedPricingEnable) {
        this.tire.sizes[0]['pricingMatrix'] = this.noMatrix[0];
      }
    }

    if (this.isNewCategoriesEnabled) {
      this.tire.category = tire.category;
    }

    if (tire.tireType) {
      this.tire.tireType = tire.tireType;
    }

    if (this.isSalesCodeEnabled) {
      this.defaultSalesCode = this.helperService.deepCopy(tire?.salesCode);
    }

    const parsedTireSize = this.helperService.tireSizeParser(tire?.size);

    // this.tire.tireWidth = parsedTireSize.tireWidth || tire.tireWidth;
    // this.tire.tireProfile = parsedTireSize.tireProfile || tire.tireProfile;
    // this.tire.tireSize = parsedTireSize.tireSize || tire.tireSize;
    // this.tire.tireSizeSearch = parsedTireSize.tireSizeSearch;

    if (this.isMultiLocationEnabled && this.isStockTransferEnabled) {
      this.partStockDetails = tire?.stockDetails || [];
      if (this.warehouses?.length) {
        const { otherLocationQty, tooltip } = this.getQtyOtherLocationTooltip();
        this.tire.sizes[0].otherLocationDataTooltip = tooltip;
        this.tire.sizes[0].otherLocationQty = otherLocationQty;
      }
    }

    this.checkShopLevelDetails();
    this.setSelectPricing();
    this.setItemRef();
    if (!this.isForceLocationUpdate) {
      this.setTireData();
    }
    this.tire.sizes[0].previousTitle = `${this.tire?.brand?.name || ''} ${tire?.model || ''} ${parsedTireSize.label || ''}`;
    this.isProcessing = false;
    if (tire?.tireExternalId && !this.tire.partsTechId) {
      this.tire.partsTechId = tire?.tireExternalId;
    }

    if (!this.isAttributeBasedPricingEnable && this.isMultiLocationEnabled) {
      const stockData = find(this.item?.stockDetails, { shopId: this.helperService.getCurrentShopId() });
      this.tire.sizes[0].isUsingFixedCost = stockData?.isUsingFixedCost || false;
      if (this.tire.sizes[0].costType !== 'cost' && !stockData && this.tireId) {
        this.tire.sizes[0].isUsingFixedCost = true;
      }
    }

    this.initialData = this.helperService.deepCopy(this.tire.sizes[0]);
  }

  checkShopLevelDetails() {
    const currentShopItemDetails = this.tire?.shopDetails?.find((s) => s.shopId === this.helperService.getCurrentShopId());
    if (currentShopItemDetails) {
      this.tire.sizes[0].price = currentShopItemDetails.price;
      this.tire.sizes[0].totalPrice = this.tire.sizes[0].count * this.tire.sizes[0].price;
      if (currentShopItemDetails?.pricing?.pricingId) {
        this.tire.sizes[0].pricingMatrix = {
          _id: currentShopItemDetails?.pricing?.pricingId,
          name: currentShopItemDetails?.pricing?.name,
        };
      } else if (currentShopItemDetails?.pricing && currentShopItemDetails?.pricing?.name) {
        this.tire.sizes[0].pricingMatrix = {
          _id: currentShopItemDetails?.pricing?.pricingId || null,
          name: currentShopItemDetails?.pricing?.name,
        };
      }
    }
  }

  setStockedCostData(costType: string, tireCost: number) {
    if (costType) {
      if (costType === 'avg') {
        this.tire.sizes[0].cost = this.averageCost;
      } else if (costType === 'latestPo') {
        this.tire.sizes[0].cost = this.latestPoCost;
      } else if (costType === 'cost') {
        //this.part.cost = this.stockCost
        this.tire.sizes[0].cost = tireCost;
      }
    }
  }

  setTireData(isMappingNeeded: boolean = false) {
    if ((this.serviceItem && this.serviceItem.itemId) || (this.serviceItem && this.serviceItem.isPreFilledPartFields)) {
      if (this.serviceItem.model) {
        this.tire.model = this.serviceItem.model;
        this.isChangeInPriceMatrix = this.serviceItem.isChangeInPriceMatrix || false;
        this.whichPricingMatrixUsed = this.serviceItem.whichPricingMatrixUsed || false;
      }

      const serviceInventoryItem = this.serviceItem?.inventoryItem || {};

      const size = {
        ...this.tire.sizes[0],
        title: this.serviceItem.title,
        description: this.serviceItem.description,
        descriptionFR: this.serviceItem.descriptionFR,
        internalNotes: this.serviceItem.internalNotes,
        notes: this.serviceItem.description,
        priceOnPO: this.serviceItem?.priceOnPO,
      };



      if (!size.associatedItems && this.serviceItem.associatedItems) {
        let getElementFromArray = this.isOpenFromRO ? this.serviceItem.associatedItems.map((itm) => {
          if (itm?.isPassThroughFet && itm?.type === 'hazmatFee') {
            itm.price = this.serviceItem?.fetValue || 0;
          }
          return itm;
        }) : this.serviceItem.associatedItems.map((itm) => {
          if (itm?.itemId?.isPassThroughFet && itm?.itemId?.type === 'hazmatFee') {
            itm.itemId.price = this.serviceItem?.fetValue || 0;
          }
          return itm.itemId;
        });

        if (this.serviceItem.associatedItems.length > 0) {
          size.hazmatFeeArray = getElementFromArray;
        } else {
          size.hazmatFeeArray = [{}];
        }
        this.feeServiceItems = size.hazmatFeeArray;
      }

      if (this.serviceItem.hasOwnProperty('seasonality')) {
        this.tire.seasonality = this.serviceItem.seasonality;
      } else if (this.serviceItem.hasOwnProperty('season')) {
        this.tire.seasonality = this.serviceItem.season;
      } else {
        if (serviceInventoryItem?.seasonality) this.tire.seasonality = serviceInventoryItem?.seasonality;
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.tire.salesCode = this.serviceItem.salesCode;
      }

      let { brand, category } = this.serviceItem;
      const tireBrand = this.brands[0];

      if (brand?.brandId || brand?.brandID) {
        this.tire.brand = {
          _id: brand.brandId || brand?.brandID,
          BrandID: brand.brandId || brand?.brandID,
          name: brand.name || brand.brandName,
        };

        if (category?.categoryId) {
          this.tire.category = this.isNewCategoriesEnabled ? { ...category } : { ...this.tire.category, ...category };
        }
      } else if (category?.name) {
        if (!this.isNewCategoriesEnabled) {

          if (brand || brand?.name) {
            const obj = find(this.brands, (item: any) => { return lowerCase(item?.name) === lowerCase(brand?.name || brand) });
            if (obj) {
              this.tire.brand = obj;
            } else {
              const itemToCreate = {
                name: brand?.name || brand,
                color: '#00C19F',
                isForFurtureUse: true,
              }
              this.handleCreateBrand(itemToCreate, true);
            }
          }

        } else if (this.isNewCategoriesEnabled) {
          const obj = find(this.tagsSuggestion, (item: any) => { return lowerCase(item?.name) === lowerCase(brand?.name || brand) });
          if (obj) {
            this.tire.brand = obj;
          }
        }

        this.tire.category = {
          name: category.name,
          categoryName: category.name,
        };

        if (category.categoryId) {
          if (this.tire.brand) {
            this.tire.brand._id = category.categoryId;
            this.tire.brand['BrandID'] = category.categoryId;
          }
        }
      } if (brand) {

        if (!this.isNewCategoriesEnabled) {
          if (brand || brand?.name) {
            const obj = find(this.brands, (item: any) => { return lowerCase(item?.name) === lowerCase(brand?.name || brand) });
            //this.tire.brand = tireBrand || { name: brand.name };
            if (obj) {
              this.tire.brand = obj;
            } else {
              const itemToCreate = {
                name: brand?.name || brand,
                color: '#00C19F',
                isForFurtureUse: true,
              }
              this.handleCreateBrand(itemToCreate, true);
            }
          }
        } else if (this.isNewCategoriesEnabled) {
          const obj = find(this.tagsSuggestion, (item: any) => { return lowerCase(item?.name) === lowerCase(brand?.name || brand) });
          if (obj) {
            this.tire.brand = obj;
          }
        }


        if (category) {
          category = typeof category === 'object' ? category?.categoryName || category?.name : category;
          this.tire.category = {
            ...this.tire.category,
            categoryName: category?.categoryName || category?.name || category,
          };
        }
      } else if (category) {
        category = typeof category === 'object' ? category.name : category;
        this.tire.category = {
          ...this.tire.category,
          categoryName: category.categoryName || category.name || category,
        };
      }

      if (this.serviceItem.supplier?.name) {
        const { supplierId, name } = this.serviceItem.supplier;
        this.tire.vendor = { name };

        if (supplierId) this.tire.vendor._id = supplierId;
      }

      if (this.serviceItem.hasOwnProperty('title')) {
        const parsedTireSize = this.helperService.tireSizeParser(this.serviceItem?.size);

        const { size_w, size_h, size_r } = serviceInventoryItem;
        const { tireWidth, tireProfile, tireSize } = this.serviceItem;

        this.tire = {
          ...this.tire,
          tireWidth: size_w || tireWidth || this.tire.tireWidth || parsedTireSize?.tireWidth,
          tireProfile: size_h || tireProfile || this.tire.tireProfile || parsedTireSize?.tireProfile,
          tireSize: size_r || tireSize || this.tire.tireSize || parsedTireSize?.tireSize,
          tireSizeSearch: parsedTireSize.tireSizeSearch
        };

        size.title = this.serviceItem.title || this.serviceItem.titleFR || '';
        size.titleFR = this.serviceItem.titleFR || this.serviceItem.title || '';
        // if (!this.tireId || !this.item) {
        //   this.setTireTitleCrtiteria('size');
        //   size.title = this.tire.sizes[0].title || this.serviceItem.titleFR || '';
        //   size.titleFR = this.tire.sizes[0].titleFR || this.serviceItem.title || '';
        // }
      }

      if (this.serviceItem.hasOwnProperty('titleFR')) {
        const parsedTireSize = this.helperService.tireSizeParser(this.serviceItem?.size);

        const { size_w, size_h, size_r } = serviceInventoryItem;
        const { tireWidth, tireProfile, tireSize } = this.serviceItem;

        this.tire = {
          ...this.tire,
          tireWidth: size_w || tireWidth || this.tire.tireWidth || parsedTireSize?.tireWidth,
          tireProfile: size_h || tireProfile || this.tire.tireProfile || parsedTireSize?.tireProfile,
          tireSize: size_r || tireSize || this.tire.tireSize || parsedTireSize?.tireSize,
          tireSizeSearch: parsedTireSize.tireSizeSearch
        };

        size.titleFR = this.serviceItem.titleFR || this.serviceItem.title || '';
        // if (!this.tireId || !this.item) {
        //   this.setTireTitleCrtiteria('size');
        //   size.titleFR = this.tire.sizes[0].titleFR || this.serviceItem.title || '';
        // }
      }

      if (this.serviceItem.hasOwnProperty('price')) {
        size.price = this.serviceItem.price;
        size.priceOnPO = size.price;
      }

      if (this.serviceItem.hasOwnProperty('cost')) {
        size.cost = this.serviceItem.cost;
        if (this.isOpenFromPO || this.isOpenFromST) {
          size.initialDefaultCost = this.serviceItem.cost;
        }
      }

      if (this.serviceItem.hasOwnProperty('isTaxable')) {
        size.isTaxable = this.serviceItem.isTaxable;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        size.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        size.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        size.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.code) {
        size.code = this.tire.tireExternalId = this.serviceItem.code;

        if (this.openFrom === 'inventoryAdd') {
          size.tireExternalId = size.tireExternalId || this.serviceItem.code;
          this.tire.partsTechId = this.tire.partsTechId || this.serviceItem.code;
        }
        if (this.serviceItem.numericItemId) {
          this.tire.tireExternalId = this.serviceItem.numericItemId;
          size.tireExternalId = this.serviceItem.numericItemId;
        }
      }

      if (this.serviceItem.size) {
        if (this.tire?.tireWidth || this.tire?.tireProfile || this.tire?.tireSize) {
          //To make it consistent ignoring the zero for the tire size against ALP-19046
          size.size = this.serviceItem.size || `${this.tire?.tireWidth || ''}${this.tire?.tireProfile && this.isOnlyZeros(this.tire?.tireProfile) ? '' : this.tire?.tireProfile || ''}${this.tire?.tireSize || ''}`
        } else {
          size.size = this.serviceItem.size;
        }
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        size.count = this.serviceItem.count;
      }

      if (this.serviceItem.hasOwnProperty('tireExternalId')) {
        size.tireExternalId = this.serviceItem.tireExternalId;
        if (!this.tire?.partsTechId) {
          this.tire.partsTechId = this.serviceItem.tireExternalId;
        }
      }

      if (this.serviceItem.hasOwnProperty('fetValue')) {
        size.fetValue = this.serviceItem.fetValue;
        if (size?.hazmatFeeArray?.length) {
          const index = findIndex(size.hazmatFeeArray, { isPassThroughFet: true });
          if (index > -1) {
            size.hazmatFeeArray[index].price = this.serviceItem.fetValue;
            size.hazmatFeeArray[index].cost = this.serviceItem.fetValue;
          }
        }
      }

      if (this.serviceItem.hasOwnProperty('category')) {
        this.setServiceItemCategory();
      }

      if (this.serviceItem.hasOwnProperty('tireType')) {
        if (this.serviceItem.tireType) {
          const tireTypeObj = find(this.tireTypeSuggestion, { name: this.serviceItem?.tireType?.name || this.serviceItem.tireType });
          if (tireTypeObj) {
            this.tire.tireType = tireTypeObj;
          }
        }
      }

      if (this.dataService.isPartWarrantiesEnabled) {
        if (this.serviceItem.hasOwnProperty('isWarrantyEligible')) {
          this.tire.isWarrantyEligible = this.serviceItem?.isWarrantyEligible;
        }
        if (this.serviceItem.hasOwnProperty('warranty')) {
          this.tire.warranty = this.serviceItem?.warranty;
        }

        if (!this.tire.isWarrantyEligible) {
          this.tire.warranty = {};
        }
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        if (size?.pricingMatrix?._id) {
          size.pricingMatrix.name = this.serviceItem.pricing.name;
          size.pricingMatrix.pricingId = this.serviceItem.pricing.pricingId;
          size.pricingMatrix.matrixAlreadyApplied = this.serviceItem.pricing?.matrixAlreadyApplied || false;
        } else {
          size.pricingMatrix = this.serviceItem.pricing;
        }

      } else if (this.serviceItem.pricing) {
        size.pricingMatrix = this.serviceItem.pricing;
      }

      if (this.serviceItem.pricing && this.serviceItem.pricing.pricingId) {
        if (size?.pricingMatrix?._id && size.pricingMatrix?._id !== this.serviceItem.pricing.pricingId) {
          size.pricingMatrix = {
            _id: this.serviceItem.pricing.pricingId,
            name: this.serviceItem.pricing.name,
            matrixAlreadyApplied: this.serviceItem.pricing?.matrixAlreadyApplied || false,
          };
        } else {
          if (size?.pricingMatrix?._id) {
            size.pricingMatrix.name = this.serviceItem.pricing.name;
            size.pricingMatrix.pricingId = this.serviceItem.pricing.pricingId;
            size.pricingMatrix.matrixAlreadyApplied = this.serviceItem.pricing?.matrixAlreadyApplied || false;
          }
        }

        size.pricingMatrixOnPO = this.helperService.deepCopy(size.pricingMatrix);
      }

      if (this.serviceItem.hasOwnProperty('itemSource')) {
        this.isPartsTechItem = ['PartsTech', 'Nexpart'].includes(this.serviceItem.itemSource);
      }

      if (this.serviceItem.hasOwnProperty('hasMarkedInventory')) {
        size.hasMarkedInventory = this.serviceItem.hasMarkedInventory;
      }

      if (this.isMarkAsInventoryEnabled) {
        size.hasMarkedInventory = this.isOpenFromPO || this.openFrom === 'inventoryAdd' || this.serviceItem?.isOpenFromInventory;
      }

      if (!isNaN(size.price) && !isNaN(size.cost) && !isNaN(size.count)) {
        size.totalPrice = this.calculationService.roundOff(Number(size.price * size.count));
        size.totalCost = this.calculationService.roundOff(Number(size.cost * size.count));
      }

      this.tire.sizes = [size];

      if (this.serviceItem.qboId) {
        this.tire.qboId = this.serviceItem.qboId;
        this.setItemRef();
      }

      if (isMappingNeeded) {
        this.setSelectPricing();
      }

      const { serviceItem, tire } = this;

      const getValue = (key) => serviceItem?.[key] ?? tire?.[key];

      this.tire = {
        ...tire,
        loadIndex: getValue('loadIndex'),
        loadIndexDual: getValue('loadIndexDual'),
        speedRating: getValue('speedRating'),
        loadRange: getValue('loadRange'),
        sideWallStyle: getValue('sideWallStyle'),
        utqg: getValue('utqg'),
        mileageRating: this.processMiles(getValue('mileageRating'))
      };

    } else {
      if (this.isOpenFromPO && this.poDetails?.onlineItem && this.poDetails?.onlineItem?.orderType !== 'TireConnect') {
        let parsedTireSizeSearch: string = '';
        if (this.poDetails?.onlineItem?.tireSize) {
          const parsedTireSize = this.helperService.tireSizeParser(this.poDetails?.onlineItem?.tireSize);
          if (!this.poDetails.onlineItem?.itemMeta) {
            this.poDetails.onlineItem.itemMeta = {};
          }
          this.poDetails.onlineItem.itemMeta.size_w = parsedTireSize.tireWidth;
          this.poDetails.onlineItem.itemMeta.size_h = parsedTireSize.tireProfile;
          this.poDetails.onlineItem.itemMeta.size_r = parsedTireSize.tireSize;
          parsedTireSizeSearch = parsedTireSize.tireSizeSearch

        }
        this.setPartsTechTireInfo(this.poDetails?.onlineItem);
        this.tire.partsTechId = this.poDetails?.onlineItem?.code;

        try {
          const [brand, ...model] = this.poDetails?.onlineItem?.title?.split(' ');
          if (model) {
            this.tire.model = model.join(' ');
          }
          this.tire.vendor = this.poDetails?.onlineItem?.supplier;
          this.tire.supplier = this.poDetails?.onlineItem?.supplier;

          if (this.poDetails?.onlineItem?.tireSize) {
            //to make it consistent and ignoring the zero or null profile against ALP-19046
            // const parsedTireSize = this.helperService.tireSizeParser(this.poDetails?.onlineItem?.tireSize);

            // this.tire.tireWidth = parsedTireSize.tireWidth;
            // this.tire.tireProfile = parsedTireSize.tireProfile;
            // this.tire.tireSize = parsedTireSize.tireSize;
            // this.tire.tireSizeSearch = parsedTireSize.tireSizeSearch;

            this.tire.tireSizeSearch = parsedTireSizeSearch;
            if (!this.tireId) {
              this.setTireTitleCrtiteria('size');
            }
          }

          if (this.poDetails?.onlineItem.attributes && this.poDetails?.onlineItem?.attributes?.length) {
            this.tire.description = this.poDetails?.onlineItem.attributes.map(({ label, value }) => `${label}: ${value}`).join(', ');

            const season = find(this.poDetails?.onlineItem.attributes, { label: 'Category' });

            if (season) {
              if (new RegExp('all season', 'i').test(season.value)) this.tire.seasonality = 'all';
              else if (new RegExp('winter', 'i').test(season.value)) this.tire.seasonality = 'winter';
              else if (new RegExp('summer', 'i').test(season.value)) this.tire.seasonality = 'summer';
              else if (new RegExp('allWeather', 'i').test(season.value)) this.tire.seasonality = 'allWeather';
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else if (this.isOpenFromPO && this.poDetails?.onlineItem && this.poDetails?.onlineItem?.orderType === 'TireConnect') {
        this.setPartsTechTireInfo(this.poDetails?.onlineItem);
        this.tire.partsTechId = this.poDetails?.onlineItem?.code;
        this.tire.model = this.poDetails?.onlineItem?.model;
        this.setPoDetailCategory();
        if (this.poDetails?.onlineItem?.tireType) {
          const tireTypeObj = find(this.tireTypeSuggestion, { name: this.poDetails?.onlineItem?.tireType });
          if (tireTypeObj) {
            this.tire.tireType = tireTypeObj;
          }
        }
        if (!this.tire.model) {
          const [model] = this.poDetails?.onlineItem?.title?.split(' ');
          if (model) {
            this.tire.model = model.join(' ');
          }
        }

        if (this.poDetails?.onlineItem?.brand) {
          const brand = find(this.brands, { name: this.poDetails?.onlineItem?.brand });
          if (brand) {
            this.tire.brand = brand;
          }
        }

        this.tire.vendor = this.poDetails?.onlineItem?.supplier;
        this.tire.supplier = this.poDetails?.onlineItem?.supplier;
        if (!this.tireId) {
          this.setTireTitleCrtiteria('size');
        }
        if (this.poDetails?.onlineItem?.season) {
          if (new RegExp('all season', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'all';
          else if (new RegExp('winter', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'winter';
          else if (new RegExp('summer', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'summer';
          else if (new RegExp('allWeather', 'i').test(this.poDetails?.onlineItem?.season)) this.tire.seasonality = 'allWeather';
        }
      }
    }
  }

  setServiceItemCategory() {
    if (this.serviceItem?.category) {
      // if (this.isNewCategoriesEnabled) {
      //   this.getNewCategories(this.serviceItem?.category?.categoryName
      //     || this.serviceItem?.category?.name
      //     || this.serviceItem?.category);
      // } else {
      const standardCategory = find(this.categoriesSuggestionsResults, {
        categoryName: this.serviceItem?.category?.categoryName || this.serviceItem?.category?.name || this.serviceItem?.category,
      });
      if (standardCategory) {
        this.tire.category = standardCategory;
      }
    }
    // }
  }

  setPoDetailCategory() {
    // if (this.isNewCategoriesEnabled) {
    //   this.getNewCategories(this.poDetails?.onlineItem?.category, true);
    // } else {
    if (this.poDetails?.onlineItem?.category) {
      const standardCategory = find(this.categoriesSuggestionsResults, { categoryName: this.poDetails?.onlineItem?.category });
      if (standardCategory) {
        this.tire.category = standardCategory;
      }
    }
    // }
  }

  onCheckboxChange(event: Event, value) {
    this.selectedFilterOptionLength = 0;

    this.isFilterLoading = true;
    if (event) {
      this.filterOption.push(value);
    } else {
      this.filterOption = this.filterOption.filter((option) => option !== value);
    }

    // add with RO
    if (value === 'ci-purchase-history-po' && event) {
      this.filterOption.push('ci-purchase-history-ro');
    } else if (value === 'ci-purchase-history-po' && !event) {
      this.filterOption = this.filterOption.filter((option) => option !== 'ci-purchase-history-ro');
    }
    this.selectedFilterOptionLength = this.filterOption.length;
    if (this.filterOption.includes('ci-purchase-history-ro')) {
      this.selectedFilterOptionLength = this.selectedFilterOptionLength - 1;
    }

    this.getLogs();
  }

  getLogs() {
    // /appLogs/getByQuery
    const query = <any>{};
    if (this.filterOption?.length) {
      query.entityType = this.filterOption;
    }
    query.entityId = this.tireId;
    query.isItemLogs = true;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
          this.isFilterLoading = false;
        }
        // if (data.items && data.items.length) {
        //   this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
        //   this.setItemRef();
        //   this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        // }
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isFilterLoading = false;
      },
    );
  }

  setSelectPricing() {
    this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
    // if (this.isAttributeBasedPricingEnable) {
    //   this.pricings = [...(this.noMatrix || []), ...(this.pricingRules || [])];
    // }
    this.pricingMatrixResults = this.helperService.deepCopy(this.pricings);
    let matrixInfo = this.helperService.deepCopy(this.isAttributeBasedPricingEnable ? this.pricingRules : this.pricings);

    if (this.tire.sizes[0].pricingMatrix && matrixInfo && matrixInfo.length) {
      const [pricing] = matrixInfo.filter(({ _id }) => _id === this.tire.sizes[0].pricingMatrix?._id || _id === this.tire.sizes[0].pricingMatrix?.pricingId);
      if (pricing) this.applyMatrix(pricing);
      else {
        if (this.isAttributeBasedPricingEnable) {
          this.setPricingMatrixForAttributeBasedPricing(matrixInfo)
        }
      }
    }
  }
  setPricingMatrixForAttributeBasedPricing(matrixInfo) {
    const locationRule = find(matrixInfo, { shopId: this.currentShopId, isCompanyLevelRule: false, itemType: 'tire' })
    const companyRule = find(matrixInfo, { isCompanyLevelRule: true, itemType: 'tire' })
    //  IF ML check Store overRide exists
    if (locationRule) this.applyMatrix(locationRule);
    else if (companyRule) this.applyMatrix(companyRule);
  }
  applyMatrix(pricing) {
    if (pricing && pricing._id) {
      if (this.isAttributeBasedPricingEnable) {
        this.checkForOverrideCategory(pricing);
      } else this.tire.sizes[0].pricingMatrix = pricing;
    }
  }

  checkForOverrideCategory(pricing) {
    // check for Regular Customer over ride
    let overRide = find(pricing?.customOverRide, {
      type: 'regular',
    });
    if (this.customerInfo?.isFleetCustomer) {
      let fleetOverRide = find(pricing?.customOverRide, {
        type: 'fleet',
      });
      // check for any Custom over ride
      let customOverRide = find(this.companyRule?.customOverRide, {
        type: 'custom',
        _id: this.customerInfo?.customTirePricingMatrix?.pricingId
      });
      if (fleetOverRide) overRide = fleetOverRide
      if (customOverRide) overRide = customOverRide
    }

    if (overRide) {
      overRide = this.helperService.deepCopy(overRide);
      overRide._id = pricing._id;
      overRide.name = pricing.name;
      const categoryId = this.makeCategoryId(this.tire?.category?._id, this.tire?.brand?._id);
      if (categoryId) {
        const overrideExist = overRide?.category?.find((c) => {
          const overrideCategoryId = this.makeCategoryId(c?._id, c?.brand?.id);
          return overrideCategoryId === categoryId;
        });
        if (overrideExist) {
          this.getUpdatedMatrixDetails(overRide, overrideExist.matrix);
        } else {
          this.getUpdatedMatrixDetails(overRide, overRide.defaultMatrix);
        }
      } else {
        this.getUpdatedMatrixDetails(overRide, overRide.defaultMatrix);
      }
    }

    if (!this.tire?.sizes[0]?.pricingMatrix?.name) {
      this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
    }
  }

  getUpdatedMatrixDetails(rule, selectMatrix) {
    if (this.tire.sizes[0].pricingMatrix?.matrixAlreadyApplied) return
    let matrixInfo = this.helperService.deepCopy(
      this.pricingMatrixList.find((m) => {
        return m._id === selectMatrix.id;
      }),
    );

    this.tire.sizes[0].pricingMatrix = rule;
    if(matrixInfo) {
      this.tire.sizes[0].pricingMatrix.items = matrixInfo?.items;
      this.tire.sizes[0].pricingMatrix.matrixName = matrixInfo?.name;
      this.tire.sizes[0].pricingMatrix.name = `${rule.name} Override (${matrixInfo?.name})`;
    }
    
  }

  checkCategoryOverAndApplyMatrix() {
    let matrixInfo = this.helperService.deepCopy(this.pricingRules);
    for (let i = 0; i < matrixInfo?.length; i++) {
      if (matrixInfo[i]._id === this.tire?.sizes?.[0]?.pricingMatrix?._id) {
        this.applyMatrix(matrixInfo[i]);
        this.calculatePrice(true);
        break;
      }
    }
  }
  makeCategoryId(categoryId, brandId) {
    let id = ''
    if (categoryId) id = categoryId
    if (id.length && brandId) id += `-${brandId}`
    if (id.length === 0 && brandId) id = brandId
    return id

  }
  _checkUniqueTitle({ title = '', index }) {
    this.tire.sizes[index].title = title;
    this.httpService.isItemTitleUnique({ title: trim(title), type: 'tire' }, this.tireId).then(
      (res) => {
        if (!this.tire.errors[index]) {
          this.tire.errors[index] = {};
        }

        if (!res) {
          this.tire.errors[index].title = 'Tire name must be unique';
          this.helperService.showToaster('error', 'Tire name must be unique');
        } else {
          this.tire.errors[index].title = '';
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: trim(this.categoryName), type: 'item' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  setPartsTechTireInfo(tire: any) {
    this.tire = {
      // brand: {
      //   ...tire?.brand,
      //   name: tire?.brand?.displayName || '',
      // },
      brand:
        typeof tire?.brand === 'string'
          ? { name: tire?.brand }
          : {
            ...tire?.brand,
            name: tire?.brand?.displayName || tire?.brand?.name || tire?.brand?.brandName || '',
          },
      errors: [],
      model: tire?.model,
      seasonality: tire?.seasonality,
      qboId: tire?.qboId,
      stocked: tire?.stocked,
      sizes: [],
    };
    if (this.poDetails?.onlineItem?.itemMeta) {
      const { size_w, size_h, size_r } = this.poDetails?.onlineItem?.itemMeta || {};
      this.tire.tireWidth = size_w || '';
      this.tire.tireProfile = size_h || '0';
      this.tire.tireSize = size_r || '';
    }
    this.defaultSizeObject = {
      ...this.defaultSizeObject,
      //adding a fix for 19046 to make the consistent behavior for ignoring the null or zero profile
      size: `${this.tire?.tireWidth || ''}${this.tire?.tireProfile && this.isOnlyZeros(this.tire?.tireProfile) ? '' : this.tire?.tireProfile || ''}${this.tire?.tireSize || ''}`,
    };
    this.tire.sizes.push(this.helperService.deepCopy(this.defaultSizeObject));
    this.tire.sizes.forEach((size: any) => {
      size.costType = tire?.costType || tire?.cost ? 'cost' : 'latestPo';
      size.isTaxable = tire?.isTaxable;
      size.count = Number(tire?.quantity);
      size.title = tire?.title;
      size.titleFR = tire?.titleFR;
      size.code = tire?.code;
      this.tire.tireExternalId = size.code;
      size.commissionable = this.dataService.isCommissionTire;
      size.cost = Number(tire?.cost);
      size.price = Number(tire?.price);
      size.description = tire?.description;
      size.descriptionFR = tire?.descriptionFR;
      size.totalCost = Number(tire?.cost) * Number(tire?.quantity);
      size.totalPrice = Number(tire?.price) * Number(tire?.quantity);
      size.hasMarkedInventory = this.isMarkAsInventoryEnabled ? this.isOpenFromPO : false;
      size.initialPrice = Number(tire.price);
    });

    const onlineItem = this.poDetails?.onlineItem;
    this.tire = {
      ...this.tire,
      loadIndex: onlineItem?.loadIndex || '',
      loadIndexDual: onlineItem?.loadIndexDual || '',
      speedRating: onlineItem?.speedRating || '',
      loadRange: onlineItem?.loadRange || '',
      sideWallStyle: onlineItem?.sideWallStyle || '',
      utqg: onlineItem?.utqg || '',
      mileageRating: this.processMiles(onlineItem?.mileageRating || ''),
    };
  }

  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
    this.errors.title = '';
  }

  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const { companyId } = this.helperService.getCompany();

      this.httpService.getCompanyDetails(companyId).then(
        (company) => {
          if (company && company.shop) {
            this.isTaxable = company.shop.tire;
            this.defaultSizeObject.isTaxable = this.isTaxable;
          }

          resolve({});
        },
        (err) => {
          reject(err);
          this.helperService.showToaster('error', err);
        },
      );
    });
  }

  deleteCategoryDialog(e) {
    this.categoryResults.forEach((x) => (x.name = x.categoryName));
    this.httpService
      .getAllCategories(e._id)
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'tire',
              isOnlyDelete: false,
              count: data.length,
              newTireModal: true && this.isNewCategoriesEnabled,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.tire && this.tire.category?.name === name) {
                this.tire.category.name = selectedName;
              }
              this.categoriesSuggestionsResults.map((item, index) => {
                if (item._id === categoryId) this.categoriesSuggestionsResults.splice(index, 1);
              });
              this.categoryResults = [...this.categoriesSuggestionsResults];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          e.categoryId = e?._id;
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'tire',
              isOnlyDelete: true,
              count: 0,
              newTireModal: true && this.isNewCategoriesEnabled,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.tire && this.tire.category?.name === name) {
                this.tire.category.name = selectedName;
              }
              this.categoriesSuggestionsResults.map((item, index) => {
                if (item._id === categoryId) this.categoriesSuggestionsResults.splice(index, 1);
              });
              this.categoryResults = [...this.categoriesSuggestionsResults];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));
  }

  handleScroll() {
    if (this.isNewItemCategoriesEnable && !this.isPartsTechItem) {
      this.offset += this.limit;
      this.getBrands();
    }

  }

  /** Fetch list of all the tags */
  async getBrands(loader = false, isClearList = false) {
    if (this.isBrandLoading || !this.hasMoreData) {
      return;
    }

    try {
      if (loader) {
        this.isBrandLoading = true;
      }
      const conf = {
        offset: this.offset,
        limit: this.limit,
        searchQuery: this.searchQuery || '',
        itemType: 'tire',
        codeType: 'brand',
      };
      if (isClearList || this.isFirstTimeLoad) {
        conf.searchQuery = '';
      }
      const response: any = await this.httpService.getPartWarrantiesBrands(conf);
      const newBrands =
        response.categories?.[0]?.records.map((brand: any) => ({
          brandName: brand.categoryName,
          name: brand.categoryName,
          brandID: brand.categoryId,
          categoryId: brand.categoryId,
          _id: brand._id,
        })) || [];

      this.brands = [...this.brands, ...newBrands];

      if (newBrands.length < this.limit && this.brands?.length > 27) {
        this.hasMoreData = false;
      }
      if (this.isFirstTimeLoad) {
        // this.setItemDetails(this.item);
      }
    } catch (err) {
      this.brands = [];
      this.helperService.showToaster('error', err);
    } finally {
      this.isBrandLoading = false;
      this.isFirstTimeLoad = false;
      const serviceItem = this.serviceItem;
    }
  }

  /** Fetch list of all the suppliers */
  getSupplierList() {
    this.httpService.getSuppliers().then(
      (vendors: any[]) => {
        if (vendors && vendors.length) {
          this.suppliers = [...vendors];
          this.vendorsSuggestion = [...this.suppliers];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /** Fetch list of all the pricings */
  getPricingList() {
    this.httpService.getPricings('part').then(
      (pricings: any[]) => {
        if (pricings && pricings.length) {
          this.pricings = pricings;
        }

        if (this.tireId) {
          this.setSelectPricing();
          this.setTireData();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  resetPagination() {
    this.searchQuery = '';
    this.offset = 0;
    this.brands = [];
    this.hasMoreData = true;
  }

  handleTagSearch(query: string) {
    if (this.isNewItemCategoriesEnable && !this.isPartsTechItem) {
      this.resetPagination();
      this.searchQuery = trim(query);
      this.tire.brand = {
        name: this.searchQuery,
      };
      this.getBrands(true);
    } else {
      if (!query) {
        return;
      }

      this.brands = this.tagsSuggestion.filter(({ name }) => new RegExp(query, 'i').test(name));
    }

  }

  handleVendorSearch(query: string) {
    if (!query) {
      return;
    }

    this.vendorsSuggestion = this.suppliers.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  handleTireTypeSearch(query: string) {
    if (!query) {
      return;
    }
    this.tireTypeSuggestion = this.defaultTireTypeSuggestion.filter(({ name }) => new RegExp(query, 'i').test(name));
  }
  openMatrixModal(selectedPricing) {
    if (selectedPricing?._id) {
      selectedPricing.id = selectedPricing._id;
    }
    const ref = this.dialogService.open(PartsPricingDialogComponent, {
      width: '850px',
      styleClass: `add-dialog`,
      showHeader: false,
      data: {
        isOpenAsDialog: true,
        selectedMatrix: selectedPricing,
        isReadOnly: true
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      onClose.unsubscribe();
    });
  }

  onSearchItem(query: string) {
    this.httpService.getQBOItemRefs(query).then(
      (data: any) => {
        if (data.items && data.items.length) {
          this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
          //this.setItemRef();
          //this.defaultQboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleClear(type: string) {
    if (type === 'vendor') {
      this.tire.vendor = {}
      this.vendorsSuggestion = [...this.suppliers];
    } else if (type === 'tireType') {
      this.tire.tireType = {}
      this.tireTypeSuggestion = [...this.defaultTireTypeSuggestion];
      this.tire.isWarrantyEligible = false;
      this.tire.warranty = {};
    } else if (type === 'category') {
      this.categoryResults = this.helperService.deepCopy(this.categoriesSuggestionsResults);
    } else if (type === 'pricingMatrix') {
      if (this.isAttributeBasedPricingEnable) {
        this.resetPricingMatrix();
      } else {
        if (this.isMultiLocationEnabled) {
          this.openPricingConfirmationModal();
        } else {
          this.resetPricingMatrix();
        }
      }

    } else if (type === 'location') {
      this.tire.sizes[0].location = {}
      this.getLocations();
    } else if (type === 'qboItemRef') {
      this.tire.sizes[0].qboItemRef = {};
      this.qboItemRefs = this.helperService.deepCopy(this.defaultQboItemRefs);
    } else if (type === 'brand') {
      this.tire.brand = {}
      this.searchQuery = '';
      this.brands = [];
      if (this.isNewCategoriesEnabled && !this.isPartsTechItem) {
        this.getBrands(true, true);
      } else {
        this.setBrands(this.tagsSuggestion);
      }

    } else {
      this.resetPagination();
      if (this.isNewCategoriesEnabled && !this.isPartsTechItem) {
        this.getBrands();
      } else {
        this.setBrands(this.tagsSuggestion);
      }


    }
  }

  handleSearch(type: string, query: string) {
    if (type === 'pricingMatrix') {
      this.pricingMatrixResults = this.pricings.filter(({ name }) => name && new RegExp(`${query}`, 'gi').test(name));
    }
  }

  openConfirmationDialog(salesCode: any) {
    let title: string = 'Confirmation';
    let message: string =
      'Updating the item classification will also auto-update the Sales Code based on the new item classification. If a Sales Code was previously assigned to this item, it will be replaced with the new sales code. Are you sure you want to proceed?';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-18 font-700',
        title: title,
        message: message,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.tire.salesCode = salesCode;
        if (salesCode?.salesCodeId) {
          this.helperService.showToaster('success', 'Sales Code was updated automatically based on the new item classification');
        }

        //this.salesCodeOverideConfirm = true;
      }
      onClose.unsubscribe();
    });
  }

  handleSelect(data: any, type: string) {
    switch (type) {
      case 'brand':
        if (this.tire.brand !== data) {
          this.isMagicFocus = false;
        }

        data.name = data.name || data.brandName;
        this.tire.brand = data;
        this.errors.brand = '';
        this.focus.brand = false;
        this.errors.title = '';
        this.checkCategoryOverAndApplyMatrix()
        break;

      case 'vendor':
        this.tire.vendor = data;
        break;

      case 'category':
        if (this.tire.category !== data) {
          this.isMagicFocus = false;
        }

        if (this.tire?.salesCode?.salesCodeId && data?.salesCode?.salesCodeId !== this.tire?.salesCode?.salesCodeId) {
          this.openConfirmationDialog(this.helperService.deepCopy(data.salesCode));
        } else {
          this.tire.salesCode = data.salesCode;
          if (data.salesCode?.salesCodeId) {
            this.helperService.showToaster('success', 'Sales Code was updated automatically based on the new item classification');
          }
        }

        this.tire.category = data;
        this.checkCategoryOverAndApplyMatrix()
        break;

      case 'tireType':
        if (this.tire.tireType !== data) {
          this.isMagicFocus = false;
        }
        this.tire.tireType = data;
        this.tire.isWarrantyEligible = false;
        this.tire.warranty = {};
        this.getWarrantyByItemSpec();
        break;

      default:
        break;
    }
    this.setTireTitleCrtiteria(type);
  }

  setTireTitleCrtiteria(type: string) {
    if (['brand', 'model', 'size'].includes(type)) {
      if (this.tire.sizes.length) {
        //is only zero added for the fix ALP-19046 for the tireProfile
        const tireSize = `${this.tire?.tireWidth || ''}${this.tire?.tireProfile && this.isOnlyZeros(this.tire?.tireProfile) ? '' : this.tire?.tireProfile || ''}${this.tire?.tireSize || ''}`;
        const title = `${this.tire?.brand?.name || ''} ${this?.tire?.model || ''} ${tireSize || ''}`;
        this.tire.sizes[0].title = title;
        this.tire.sizes[0].previousTitle = title;
        if (this.companyLocalization) {
          const titleFR = `${this.tire?.brand?.name || ''} ${this?.tire?.model || ''} ${tireSize || ''}`;
          this.tire.sizes[0].titleFR = titleFR;
          this.tire.sizes[0].previousTitleFR = titleFR;
        }
      }
    }
  }

  handleChange(value: string, type: string) {
    // unselect seasonlity
    if (type === 'seasonality') {
      if (value === this.tire.seasonality) {
        value = '';
      }
    }
    if (type === 'hasMarkedInventory') {
      //this.tire.stocked = value;
      //this.tire.sizes[0].stocked = value;
      this.tire.sizes[0].hasMarkedInventory = value;
    }

    if (type === 'tireExternalId') {
      if (value === '') {
        this.isShowPartSuggestions = true;
        this.resetAutofillFields();
      } else {
        this.isShowPartSuggestions = false;
      }
    }

    if (type === 'isWarrantyEligible') {
      if (value) {
        this.getWarrantyByItemSpec();
      } else {
        this.tire.warranty = {};
      }
    }

    if (this.isMagicFocus) this.isMagicFocus = false;

    this.tire[type] = value;
    this.errors[type] = '';
    this.setTireTitleCrtiteria(type);
  }

  graphdata(itemId, type) {
    this.httpService.getSalesTrendHistory(itemId, type).then((res: any) => {
      this.dataService.stockItemdata.next(res.trend);
    });
  }

  handleClearCostType(type: string, value) {
    if (type === 'costType') {
      this.tire.sizes[0].costType = {}
    }
  }

  openPricingConfirmationModal() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'Confirmation',
        message: `This action will remove the pricing matrix and update the price for this item across all locations.`,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
        this.pricingMatrixResults = [...this.pricings];
      } else {
        this.calculatePrice();
      }

      //this.cdr.detectChanges();
      onClose.unsubscribe();
    });
  }

  handleSizeChange(type: string, value: any) {

    if (type === 'fetValue') {
      this.tire.sizes[0][type] = Number(value);
    } else {
      this.tire.sizes[0][type] = value;
    }

    if (type === 'costType') {
      this.tire.sizes[0][type] = value?.value;
      if (this.tire?.stocked && !this.isOpenFromPO && !this.isOpenFromST && !this.isOpenFromRO) {
        if (value?.value === 'avg') {
          this.tire.sizes[0].cost = this.averageCost;
        } else if (value?.value === 'latestPo') {
          this.tire.sizes[0].cost = this.latestPoCost;
        } else {
          this.tire.sizes[0].cost = this.tire.sizes[0]?.initialDefaultCost;
        }
      }
      this.applyMatrix(this.tire.sizes[0].pricingMatrix);
      this.calculatePrice();
    }

    this.onFieldUpdateOnSize({
      field: type,
      isUpdated: this.initialData[type] !== value,
    });

    if (type === 'cost') {
      this.calculatePrice();
    }
    if (type === 'price' && !this.isMultiLocationEnabled) {
      this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
    }

    if (type === 'title' || type === 'titleFR' || type === 'size' || type === 'cost' || type === 'price') {
      if (this.isMagicFocus && this.dataService.isUseOnlinePricing && ['price', 'cost'].includes(type)) {
        this.isMagicFocus = false;
      }

      if ((type === 'title' || type === 'size') && this.isMagicFocus) {
        this.isMagicFocus = false;
      }

    }
    if (type === 'pricingMatrix') {
      this.applyMatrix(value);
      this.calculatePrice();
    }
  }

  parsePTTireAttr = (attributes) => {
    const loadIndex = find(attributes, { name: 'TiresLoadIndex' })?.value;
    const speedRating = find(attributes, { name: 'TiresSpeedRating' })?.value;
    const loadRange = find(attributes, { name: 'TiresLoadRange' })?.value;
    const sideWallStyle = find(attributes, { name: 'TiresSideWallStyle' })?.value;
    const utqg = find(attributes, { name: 'TiresQuality' })?.value;
    const mileageRating =
      this.processMiles(
        find(attributes, { name: 'TiresMileageRating' })?.value
        || '');
    return {
      loadIndex,
      speedRating,
      loadRange,
      sideWallStyle,
      mileageRating,
      utqg
    };
  };

  processutqgInput(): void {
    // Split the input value by spaces
    const parts = trim(this.tire.utqg).split(/\s+/);

    // Validate and assign values
    this.utgq.wear = parts[0]?.length === 3 ? parts[0] : ''; // Wear must be exactly 3 characters
    this.utgq.traction = parts[1]?.length === 1 ? parts[1] : ''; // Traction must be exactly 1 character
    this.utgq.temp = parts[2]?.length === 1 ? parts[2] : ''; // Temp must be exactly 1 character
  }

  parseutqg(value) {
    // Check if the value is an object
    if (typeof value === 'object' && value !== null) {

      const { wear, traction, temp } = value;

      this.utgq = null;
      if (wear && traction && temp) {
        this.utgq = { wear, traction, temp };
      }
      if (wear && traction && temp) {
        return trim(`${wear} ${traction} ${temp}`); // Format directly from the object
      }
      return ''; // Return empty string if any field is missing
    }

    // If value is a string
    if (typeof value === 'string') {
      const sanitizedInput = value.replace(/\s+/g, '');

      let formatted = '';
      const wear = sanitizedInput.slice(0, 3); // First 3 digits (Wear)
      const traction = sanitizedInput.slice(3, 4); // Next single character (Traction)
      const temp = sanitizedInput.slice(4, 5); // Next single character (Temp)

      // Rebuild formatted string with spaces
      if (wear) formatted += wear;
      if (traction) formatted += ' ' + traction;
      if (temp) formatted += ' ' + temp;

      this.utgq = null;
      if (wear && traction && temp) {
        this.utgq = { wear, traction, temp };
      }
      return trim(formatted); // Update the input value
    }

    return ''; // Return empty string for unsupported types
  }

  getFetFee(sizeIndex = 0) {
    const feeIndex = findIndex(this.tire.sizes[sizeIndex].hazmatFeeArray, (fee: any) => {
      if (fee?.isPassThroughFet) {
        return true;
      } else {
        return false;
      }
    });
    if (feeIndex > -1) {
      if (!this.tire.sizes[sizeIndex].fetValue) {
        const message: string = 'Are you sure you want to disassociate it?.';
        this.openConfirmationPrompt(feeIndex, sizeIndex, message);
      } else {
        this.tire.sizes[sizeIndex].hazmatFeeArray[feeIndex].price = this.tire.sizes[sizeIndex].fetValue;
        this.feeServiceItems = this.tire.sizes[sizeIndex].hazmatFeeArray;
      }

      this.isAssigningFET = false;
      return;
    }

    if (!this.tire.sizes[sizeIndex].fetValue) {
      this.isAssigningFET = false;
      return;
    }

    this.httpService
      .getItems({
        limit: 1,
        type: 'hazmatFee',
        fetchFETFee: true,
      })
      .then(
        (res: any) => {
          if (res) {
            if (Array.isArray(this.tire.sizes[sizeIndex].hazmatFeeArray)) {
              if (this.tire.sizes[sizeIndex].hazmatFeeArray.length
                && !this.tire.sizes[sizeIndex].hazmatFeeArray[0]?._id) {
                this.tire.sizes[sizeIndex].hazmatFeeArray[0] = res;
              } else {
                this.tire.sizes[sizeIndex].hazmatFeeArray.push(res);
              }
            }
            this.onROSelect(res, this.tire.sizes[sizeIndex].hazmatFeeArray.length - 1);
            const fetFeeIndex = this.tire.sizes[sizeIndex].hazmatFeeArray.length - 1;
            this.tire.sizes[sizeIndex].hazmatFeeArray[fetFeeIndex].price = this.tire.sizes[sizeIndex].fetValue;
          }

          this.isAssigningFET = false;
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
          this.isAssigningFET = false;
        },
      );
  }

  calculateMarkupShopWise(cost: any) {
    if (!cost || !Object.keys(this.tire?.sizes[0]?.pricingMatrix || [])?.length || this.tire?.sizes[0]?.pricingMatrix?.name === 'No pricing rules') {
      return this.tire?.sizes[0].price;
    }
    let markup = 0;
    const itemsLength = this.tire.sizes[0].pricingMatrix && this.tire.sizes[0].pricingMatrix.items && this.tire.sizes[0].pricingMatrix.items.length;

    if (itemsLength) {
      for (let i = 0; i < itemsLength; i++) {
        const item = this.tire.sizes[0].pricingMatrix.items[i];
        if (cost >= item.min && cost <= item.max) {
          markup = item.markup;
          break;
        }
      }
    }
    let price: any = this.calculationService.calculateMarkUpPrice(cost, markup);

    price = this.calculationService.roundOff(price);

    return price;
  }

  calculatePrice(setPrice = true) {
    if (!this.tire?.sizes[0]?.cost || !Object.keys(this.tire?.sizes[0]?.pricingMatrix || [])?.length || this.tire?.sizes[0]?.pricingMatrix?.name === 'No pricing rules') {
      return;
    }
    let markup = 0;
    const itemsLength = this.tire.sizes[0].pricingMatrix && this.tire.sizes[0].pricingMatrix.items && this.tire.sizes[0].pricingMatrix.items.length;

    if (itemsLength) {
      for (let i = 0; i < itemsLength; i++) {
        const item = this.tire.sizes[0].pricingMatrix.items[i];
        if (this.tire.sizes[0].cost >= item.min && this.tire.sizes[0].cost <= item.max) {
          markup = item.markup;
          break;
        }
      }
    }
    const price: any = this.calculationService.calculateMarkUpPrice(this.tire.sizes[0].cost, markup);

    if (setPrice) {
      this.tire.sizes[0].price = this.calculationService.roundOff(price);
    }

    this.calculatedAmount = this.calculationService.roundOff(price);
    this.isAddedManually = Number(this.tire.sizes[0].price) !== Number(this.calculatedAmount);
    this.tire.sizes[0].totalPrice = this.calculationService.roundOff(Number(this.tire.sizes[0].price * this.tire.sizes[0].count));
    this.tire.sizes[0].totalCost = this.calculationService.roundOff(Number(this.tire.sizes[0].cost * this.tire.sizes[0].count));
    if (this.isAttributeBasedPricingEnable) {
      this.whichPricingMatrixUsed = `${this.tire.sizes[0].pricingMatrix.name}:${this.tire.sizes[0].pricingMatrix.matrixName}:${markup}`;
    }

    this.onFieldUpdateOnSize({
      field: 'price',
      isUpdated: this.initialData['price'] !== this.tire.sizes[0].price,
      whichPricingMatrixUsed: this.whichPricingMatrixUsed,
    });

    this.errors.price = '';
  }

  checkPricingBackwardCompatibility() {
    const currentShopDetails = find(this.tire.sizes[0]?.shopDetails, { shopId: this.helperService.getCurrentShopId() });
    if (currentShopDetails && this.tire.sizes[0]?.price !== currentShopDetails?.price && !this.isOpenFromPO && !this.isOpenFromRO && !this.isOpenFromST) {
      this.tire.sizes[0].price = currentShopDetails?.price;
      this.isAddedManually = Number(this.tire.sizes[0].price) !== Number(this.calculatedAmount);
      if (this.isAddedManually) {
        this.tire.sizes[0].pricingMatrix = {};
      }
    } else if (this.isOpenFromPO || this.isOpenFromRO || this.isOpenFromST) {
      this.tire.sizes[0].pricingMatrix = this.tire.sizes[0].pricingMatrixOnPO;
      if (this.tire.sizes[0].price !== this.tire.sizes[0].priceOnPO) {
        this.tire.sizes[0].pricingMatrix = {};
      }
      this.tire.sizes[0].price = this.tire.sizes[0].priceOnPO;
    } else {
      if (this.tire.sizes[0].initialPrice >= 0 && this.tire.sizes[0].price !== this.tire.sizes[0].initialPrice && !currentShopDetails) {
        this.tire.sizes[0].price = this.tire.sizes[0].initialPrice;
      }
    }
    this.tire.sizes[0].totalPrice = this.tire.sizes[0].price * this.tire.sizes[0].count;
  }

  handleBlur(type: string) {
    if (
      type === 'category' ||
      type === 'model' ||
      type === 'brand' ||
      type === 'subCategory' ||
      type === 'subSubCategory' ||
      type === 'internalNotes' ||
      type === 'description' ||
      type === 'descriptionFR' ||
      type === 'title' ||
      type === 'titleFR' ||
      type === 'tireExternalId' ||
      type === 'location' ||
      type === 'restockLevel' ||
      type === 'maxQuantity' ||
      type === 'fetValue' ||
      type === 'price' ||
      type === 'cost' ||
      type === 'count' ||
      type === 'cost' ||
      type === 'cost'
    ) {
      this.focus[type] = false;
    }

    if (type === 'fetValue') {
      this.isAssigningFET = true;
      this.getFetFee(0);
    }

    if (type === 'price') {
      if (this.isMultiLocationEnabled && !this.isAttributeBasedPricingEnable && this.isManuallyAdded()) {
        if (Object.keys(this.tire.sizes[0]?.pricingMatrix || {})?.length && this.tire?.sizes[0]?.pricingMatrix?.name !== 'No pricing rules') {
          this.openPricingConfirmationModal();
        }
      }
    }
  }

  handleFocus(type: string) {
    if (!['tireWidth', 'tireProfile', 'tireSize'].includes(type)) {
      this.focus = {};
    }
    this.errors[type] = '';
    this.focus[type] = true;
    if (this.focus.tireExternalId) {
      this.isShowPartSuggestions = true;
    }
    if (type === 'brand') {
      if (!this.isNewCategoriesEnabled) {
        this.brands = this.helperService.deepCopy(this.tagsSuggestion);
      }
    }
  }

  onFieldUpdateOnSize(event) {
    const { field, isUpdated, whichPricingMatrixUsed } = event;
    if (field === 'price' || field === 'cost' || field === 'count' || field === 'description' || field === 'isTaxable' || field === 'internalNotes') {
      this.updatedInputStates[field] = isUpdated;
    }
    if (field === 'pricingMatrix') {
      if (!this.isPricingManagementEnable || !this.isPricingMatricesManagement || this.isPricingMatricesManagement === undefined) {
        this.isChangeInPriceMatrix = true;
        this.updateGenericItem = false;
      }
    } else if (field === 'price') {
      this.tire.isPriceManuallyAdded = true;
      this.tire.whichPricingMatrixUsed = whichPricingMatrixUsed;
    }
  }

  handleAddSize() {
    this.itemResults = [[]];
    const size = this.helperService.deepCopy(this.defaultSizeObject);
    size.title = [this.tire?.brand?.name, this.tire.model].filter((str) => str).join(' ');
    size.commissionable = this.dataService.isCommissionTire;
    this.tire.sizes.push(size);
  }

  handleDeleteTireSize(index: number) {

    this.tire.sizes.splice(Number(index), 1);
    this.tire.errors[index] = {};
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }

  handleValidation() {
    let isValid = true;

    // if (!this?.tire?.brand?.brandID || !this?.tire?.brand?.name) {
    if (!this?.tire?.brand?.name) {
      this.errors.brand = '* Brand is required';
      isValid = false;
    }

    if (!this.tire.model) {
      this.errors.model = '* Model is required';
      isValid = false;
    }

    const duplicatedTitles = this.tire.sizes.reduce((accumulator, currentItem, currentItemIndex, array) => {
      const index = array.findIndex((x) => x.title === currentItem.title);
      const duplicate = index !== currentItemIndex;

      if (duplicate) {
        return [...accumulator, currentItemIndex];
      } else return accumulator;
    }, []);

    this.tire.sizes.forEach(({ title, titleFR, cost, count, price, size, maxQuantity, restockLevel, hasMarkedInventory, location, costType }: any, index: number) => {
      if (this.companyLocalization && this.currentLang === 'fr') {
        if (!titleFR || !this.helperService.trimString(titleFR)) {
          this.errors.titleFR = '* Tire name required';
          isValid = false;
        }
      } else {
        if (!title || !this.helperService.trimString(title)) {
          this.errors.title = '* Tire name required';
          isValid = false;
        }

        if (duplicatedTitles && duplicatedTitles.length > 0 && duplicatedTitles.includes(index)) {
          this.errors.title = 'Tire name must be unique';
          this.helperService.showToaster('error', 'Tire name must be unique');
          isValid = false;
        }
      }

      if (!trim(cost) && costType === 'cost') {
        this.errors.cost = '* Cost is required';
        isValid = false;
      }

      // check if item is inventory
      // if (this.tire.stocked && !location) {
      if ((this.tire.stocked || hasMarkedInventory) && (!location || !location?.locationId)) {
        this.errors.location = '* Location is required';
        this.helperService.showToaster('error', 'Location is required');
        isValid = false;
      }

      if ((this.tire.stocked || hasMarkedInventory) && !this.isAttributeBasedPricingEnable) {
        if (!location || !location?.locationId) {
          this.errors.location = '* Location is required';
          this.helperService.showToaster('error', 'Location is required');
          isValid = false;
        }
      }

      // check if item is inventory
      if ((this.tire.stocked || hasMarkedInventory) && Number(maxQuantity) < Number(restockLevel)) {
        this.errors.restockLevel = 'Minimum quantity level can not be greater than the maximum quantity level';
        isValid = false;
      }

      if (!count) {
        this.errors.count = '* Default qty required';
        isValid = false;
      }

      if (!trim(price)) {
        this.errors.price = '* Price is required';
        isValid = false;
      }

      // const tireSize = this.isOnlyZeros(this.tire?.tireSize);
      // const tireProfile = this.isOnlyZeros(this.tire?.tireProfile);
      // const tireWidth = this.isOnlyZeros(this.tire?.tireWidth);

      // if (tireSize || !this.helperService.trimString(String(this.tire?.tireSize))) {
      //   this.errors.tireSize = '* Tire size is required';
      //   isValid = false;
      // }

      // if (tireProfile || !this.helperService.trimString(String(this.tire?.tireProfile))) {
      //   this.errors.tireProfile = '* Tire profile is required';
      //   isValid = false;
      // }

      // if (tireWidth || !this.helperService.trimString(String(this.tire?.tireWidth))) {
      //   this.errors.tireWidth = '* Tire width is required';
      //   isValid = false;
      // }

      if (this.openFrom === 'inventoryAdd' && (!location || !location.locationId)) {
        // check if item is inventory
        this.errors.location = '* Location is required';
        this.helperService.showToaster('error', 'Location is required');
        isValid = false;
      }
    });

    return isValid;
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.tire && this.tire.qboId && this.qboItemRefs.length) {
      if (this.tire.sizes[0]) {
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: this.tire.qboId,
        });
      }
    }
    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.tire && this.tire.locationQboItemRefId && this.tire.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.tire.locationQboItemRefId[this.currentShopId];
        this.tire.sizes[0].qboItemRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  getFeeArrayList(feeArray) {
    const hazamFeeList = [];
    feeArray.map((itm) => {
      if (itm && itm._id) {
        hazamFeeList.push({ itemId: itm._id });
      }
    });
    return hazamFeeList;
  }

  makeTirePayload(checkStockOnOrder: boolean = true, isOpenCreate: boolean = false) {
    const tires = [];
    // let tireSize = `${this.tire?.tireWidth}/${this.tire?.tireProfile}${this.tire?.tireSize}`
    this.tire.sizes.forEach((size: any) => {
      const tire: any = {
        isForceStockUpdate: !checkStockOnOrder,
        //cost: Number(size.cost),
        category: this.tire.category,
        price: Number(size.price),
        code: size.code,
        title: size.title,
        titleFR: size.titleFR,
        model: this.tire.model,
        size: this.tire.sizes[0].size,
        tireWidth: this.tire?.tireWidth,
        tireSize: this.tire?.tireSize,
        tireProfile: this.tire?.tireProfile,
        type: 'tire',
        count: size.count,
        commissionable: size.commissionable,
        description: size.description,
        descriptionFR: size.descriptionFR,
        internalNotes: size.internalNotes,
        notes: size.description,
        isTaxable: size.isTaxable,
        status: size.status,
        costType: size.costType,
        stocked: size.stocked,
        shopDetails: this.tire.shopDetails,
        hasMarkedInventory: size?.hasMarkedInventory || size?.stocked,
        seasonality: this.tire.seasonality,
        locationQboItemRefId: this.tire.locationQboItemRefId || {},
        displayDescOnOrder: size.displayDescOnOrder,
        displayHoursOnOrder: size.displayHoursOnOrder,
        associatedItems: this.getFeeArrayList(size.hazmatFeeArray),
        isChangeInPriceMatrix: this.isChangeInPriceMatrix,
        isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
        whichPricingMatrixUsed: this.tire.whichPricingMatrixUsed,
        partsTechId: this.tire.partsTechId,
        tireExternalId: this.tire?.tireExternalId || '',
        partsTechDetails: {},
        loadIndex: this.tire?.loadIndex || '',
        loadIndexDual: this.tire?.loadIndexDual || '',
        speedRating: this.tire?.speedRating || '',
        loadRange: this.tire?.loadRange || '',
        sideWallStyle: this.tire?.sideWallStyle || '',
        mileageRating: this.processMiles(
          this.tire?.mileageRating
          || '')
      };
      this.processutqgInput();
      tire.wear = this.utgq.wear;
      tire.temp = this.utgq.temp;
      tire.traction = this.utgq.traction;
      tire.utqg = this.tire?.utqg;

      if (tire.hasMarkedInventory || tire.stocked) {
        tire.restockLevel = size.restockLevel;
        tire.maxQuantity = size.maxQuantity;
      }

      if (this.isQTQAddOnEnable) {
        tire.tireExternalId = this.tire?.tireExternalId || '';
      }

      tire.code = tire?.tireExternalId || tire?.code || '';
      tire.partsTechDetails.partNumber = tire?.tireExternalId || tire?.code || '';

      if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
        if (this.tire.salesCode && this.tire.salesCode?.salesCodeId) tire.salesCode = this.tire.salesCode;
        else tire.salesCode = {};
      }

      //we only update cost when the cost type is cost - ALP-15794
      if (size.costType !== 'avg' && size.costType !== 'latestPo') {
        tire.cost = Number(size.cost);
      }

      if (this.isOpenFromPO) {
        tire.cost = Number(size.cost);
      }

      if (this.tire.brand) {
        tire.brand = this.tire.brand.name;
        tire.brandId = this.tire.brand._id;
      }

      const catergoryId = this.tire.category?._id || this.tire?.category?.categoryId;
      const categoryName = this.tire?.category?.name || this.tire?.category?.categoryName;
      // tire.category = tire.category;
      if (!this.dataService.isNewItemCategoriesEnable) {
        if (categoryName || catergoryId) {
          tire.category = {
            categoryId: catergoryId || '',
            categoryName: categoryName || '',
          };
        }
      }

      tire.partSpecification = {};
      tire.partSpecification = this.tire.partSpecification || {};
      if (this.tire.brand) {
        tire.partSpecification.brand = {
          id: this.tire.brand._id || this.tire.brand.brandID,
          name: this.tire.brand.name,
        };
      }

      if (this.tire.vendor?._id || this.tire.vendor?.supplierId || this.tire.vendor?.name) {
        tire.supplier = {
          supplierId: this.tire.vendor._id || this.tire.vendor?.supplierId,
          name: this.tire.vendor.name,
        };
      }

      if (this.tire.tireType) {
        tire.tireType = {
          tireTypeId: this.tire?.tireType?.tireTypeId,
          name: this.tire?.tireType?.name,
          isCommercial: this.tire?.tireType?.isCommercial,
        };
      }

      if (this.dataService.isPartWarrantiesEnabled) {
        tire.isWarrantyEligible = this.tire?.isWarrantyEligible;
        if (this.tire?.warranty?.warrantySettingId) {
          tire.warranty = this.tire.warranty;
        }
      }

      if (size?.hasOwnProperty('fetValue')) {
        tire.fetValue = Number(size?.fetValue) || 0;
      }

      if (size.location && size.location.locationId) {
        tire.locations = [size.location];
      }

      if (size?.qboItemRef?.qboId) {
        tire.qboItemRefId = size.qboItemRef.qboId;
        tire.qboId = size.qboItemRef.qboId;
        if (this.isMultiLocationEnabled) {
          tire.locationQboItemRefId[this.currentShopId] = tire.qboId;
        }
      }

      if (size.pricingMatrix) {
        tire.pricing = {
          pricingId: size.pricingMatrix?._id || null,
          name: size.pricingMatrix?.name,
        };
      }
      this.checkShopLevelDetailsAdded(tire, isOpenCreate);
      if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
        tire.isAutoAssign = this.isAutoAssign;
      }
      if (this.isMagicFocus) {
        tire.magicFillCost = this.tooltipData.magicFillCost;
        tire.magicFillPrice = this.tooltipData.magicFillPrice;
        tire.magicFillDate = this.dateService.getCurrentDateTimeTz(new Date().getTime());
        tire.isMagicFill = this.tooltipData.isMagicFill;
      }
      tires.push(tire);
    });

    return tires;
  }

  checkShopLevelDetailsAdded(tire, isOpenCreate) {
    if (!tire.shopDetails || tire.shopDetails.length === 0) {
      tire.shopDetails = [
        {
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: tire?.pricing?.pricingId || null,
            name: tire?.pricing?.name,
          },
          price: tire.price,
          stocked: tire.stocked,
          maxQuantity: tire.maxQuantity || 0,
          restockLevel: tire.restockLevel || 0,
          whichPricingMatrixUsed: `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`,
        },
      ];
    } else {
      const shopLevelDetails = findIndex(tire.shopDetails, {
        shopId: this.helperService.getCurrentShopId(),
      });
      if (shopLevelDetails === -1) {
        tire.shopDetails.push({
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: tire?.pricing?.pricingId,
            name: tire?.pricing?.name,
          },
          price: tire.price,
          stocked: tire.stocked,
          maxQuantity: tire.maxQuantity || 0,
          restockLevel: tire.restockLevel || 0,
          whichPricingMatrixUsed: `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`,
        });
      } else {
        tire.shopDetails[shopLevelDetails].pricing = {
          pricingId: tire?.pricing?.pricingId,
          name: tire?.pricing?.name,
        },
          tire.shopDetails[shopLevelDetails].price = tire.price;
        tire.shopDetails[shopLevelDetails].stocked = tire.stocked;
        tire.shopDetails[shopLevelDetails].maxQuantity = tire.maxQuantity;
        tire.shopDetails[shopLevelDetails].restockLevel = tire.restockLevel;
        tire.shopDetails[shopLevelDetails].whichPricingMatrixUsed = `${tire?.pricing?.name}:${tire?.pricing?.matrixName}:${tire?.price}`;
      }
    }

    if (this.isAttributeBasedPricingEnable) {
      if (!isOpenCreate && !this.isOpenFromRO && !this.isOpenFromPO && !this.isOpenFromST) {
        delete tire.pricing;
        delete tire.price;
        delete tire.whichPricingMatrixUsed;
      }
    } else {
      if (tire.costType !== 'cost' && Object.keys(Object.keys(this.tire?.sizes[0]?.pricingMatrix || {})?.length && this.tire?.sizes[0]?.pricingMatrix?.name !== 'No pricing rules')) {
        tire.price = this.calculateMarkupShopWise(this.item?.cost);
      }
      this.updatePricingToAllShops(tire);
    }
    return tire;
  }

  updatePricingToAllShops(item: any) {
    item?.shopDetails?.forEach((shopDetail: any) => {
      const stockData = find(this.item?.stockDetails, { shopId: shopDetail?.shopId });
      shopDetail.pricing = {
        pricingId: item?.pricing?.pricingId,
        name: item?.pricing?.name,
      };
      let cost = item.cost;
      if (stockData) {
        if (item.costType === 'avg') {
          cost = stockData.averageCost;
        } else if (item.costType === 'latestPo') {
          cost = stockData.latestPoCost;
        }
      } else {
        if (this?.item?.hasOwnProperty('cost') && item?.costType !== 'cost') {
          cost = this.item?.cost;
        }
      }
      shopDetail.price = this.calculateMarkupShopWise(cost),
        shopDetail.whichPricingMatrixUsed = `${item?.pricing?.name}:${item?.pricing?.matrixName}:${item?.price}`;
    });
  }

  handleSubmit(checkStockOnOrder: boolean = true) {
    if (!this.handleValidation() || this.isProcessing || this.isAssigningFET) {
      //   if (this.isAssigningFET) {
      //     this.helperService.showToaster('error', 'Assigning FET (Federal Excise Tax)')
      //   }

      return;
    }

    if (this.tireId || (this.serviceItem && this.serviceItem.itemId)) {
      this.handleUpdateTire(this.makeTirePayload(checkStockOnOrder, false));
    } else {
      this.handleCreateTire(this.makeTirePayload(true, true));
    }
  }

  async getWarehouses() {
    const warehouseData: any = await this.httpService.getWarehouses();
    if (warehouseData.records?.length) {
      this.warehouses = warehouseData.records;
      if (this.warehouses?.length && !this.tire.sizes[0].otherLocationDataTooltip && this.partStockDetails?.length) {
        const { otherLocationQty, tooltip } = this.getQtyOtherLocationTooltip();
        this.tire.sizes[0].otherLocationDataTooltip = tooltip;
        this.tire.sizes[0].otherLocationQty = otherLocationQty;
      }
    }
  }

  getQtyOtherLocationTooltip() {
    let tooltip = '';
    let otherLocationQty = 0;
    if (this.partStockDetails?.length) {
      let locData: string = '';
      this.partStockDetails.forEach((location) => {
        const warehouse = find(this.warehouses, (item: any) => {
          if (this.dataService.warehouse?.warehouseId !== item?._id && item?._id === location?.warehouseId) {
            return true;
          }
        });

        if (location?.warehouseId === warehouse?._id) {
          otherLocationQty += location?.countAvailable;
          locData =
            locData +
            `
        <div class="flex-between-center pb-1">
          <span class="font-10 font-400">${warehouse?.name || ''}</span>
          <span class="font-10 font-400">${this.calculationService.roundOff(location?.countAvailable)}</span>
        </div>`;
        }
      });
      if (locData) {
        tooltip = `
      <div class="flex-column p-1">
        <div class="border-bottom-white flex-between-center pb-1 mb-2">
          <span class="font-12 font-400">Warehouse</span>
          <span class="font-12 font-400">QTY</span>
        </div>
        ${locData}
      </div>`;
      }
    }
    otherLocationQty = this.calculationService.roundOff(otherLocationQty);
    return { otherLocationQty, tooltip };
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  handleUpdateTire([tire]: any[]) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    // if(this.isMagicFocus) {
    //   tire = {
    //     ...tire,
    //     ...this.tooltipData
    //   }
    // }

    if (this.openFrom === 'inventoryAdd') {
      this.isProcessing = false;
      this.handleCloseModal();

      if (this.tireId) {
        tire._id = this.tireId;
      }

      this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...tire }));
    } else if ((this.orderServiceId || this.isOpenFromPO) && !this.updateGenericItem && !this.isOpenFromMO && !this.isForceLocationUpdate) {
      this.handleCloseModal();
      this.isProcessing = false;

      if (this.isSalesCodeEnabled && tire?.salesCode?.salesCodeId && this.serviceItem?.salesCode?.salesCodeId !== tire?.salesCode?.salesCodeId) {
        this.logPXGaingSightCustomEvent(tire);
      }

      if (this.isOpenFromPO) {
        if (this.tireId) {
          tire._id = this.tireId;
        }

        this.dataService.sendData(
          this.dataService.typePassData('po-service-item', {
            ...tire,
            actionType: 'update',
            poDetails: this.poDetails,
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
          }),
        );
      } else if (this.orderServiceId) {
        if (this.tireId) {
          tire._id = this.tireId;
        }
        if (tire.cost) {
          tire.cost = this.formatService.setDynamicCostAndPrice(tire, 'cost');
        }

        if (this.dataService.isPartWarrantiesEnabled) {
          if (tire?.isWarrantyEligible && !this.isOpenFromPO) {
            const index = findIndex(this.serviceItem.tags, { tagType: 'partWarranties' });
            if (index < 0) {
              this.handlePartWarrantiesItem(tire, 'update');
            } else {
              this.dataService.sendData(
                this.dataService.typePassData('ro-service-item', {
                  ...tire,
                  actionType: 'update',
                  isLocal: true,
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                  isChangeInPriceMatrix: this.isChangeInPriceMatrix,
                  whichPricingMatrixUsed: this.whichPricingMatrixUsed,
                  isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
                  feeServiceItems: this.feeServiceItems,
                }),
              );
            }
          } else {
            tire.warranty = {};
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...tire,
                actionType: 'update',
                isLocal: true,
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
                isChangeInPriceMatrix: this.isChangeInPriceMatrix,
                whichPricingMatrixUsed: this.whichPricingMatrixUsed,
                isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
                feeServiceItems: this.feeServiceItems,
              }),
            );
          }
        } else {
          this.dataService.sendData(
            this.dataService.typePassData('ro-service-item', {
              ...tire,
              actionType: 'update',
              isLocal: true,
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
              isChangeInPriceMatrix: this.isChangeInPriceMatrix,
              whichPricingMatrixUsed: this.whichPricingMatrixUsed,
              isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
              feeServiceItems: this.feeServiceItems,
            }),
          );
        }
      }
    } else {
      const item = this.helperService.deepCopy(tire);
      if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
        tire.salesCode = this.defaultSalesCode;
      }
      if (this.isOpenFromMO) {
        tire.isUpdateLocationOnly = true;
        tire.orderId = this.orderId;
      }
      this.httpService.updateItem({ ...tire, _id: this.tireId }).then(
        (res: any) => {
          this.handleCloseModal();

          if (res.cost) {
            res.cost = this.formatService.setDynamicCostAndPrice(res, 'cost');
          }

          if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
            res.salesCode = item?.salesCode;
          }

          if (this.isSalesCodeEnabled) {
            this.logPXGaingSightCustomEvent(res);
          }

          if (this.isOpenFromMO) this.dataService.sendData(this.dataService.typePassData('manual-order-update', title));
          this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
          this.helperService.showToaster('success', 'Tire updated');
          this.isProcessing = false;
          if (this.isOpenFromPO) {
            if (res && res.length > 0) {
              res.forEach((item: any) => {
                item.actionType = 'update';
                if (!item.itemId) {
                  item.itemId = item._id;
                }
              });
            }
            this.dataService.sendData(
              this.dataService.typePassData('po-service-item', {
                ...res,
                items: res,
                actionType: 'update',
                poDetails: this.poDetails,
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              }),
            );
          }

          if (this.orderServiceId) {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...res,
                actionType: 'update',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
                feeServiceItems: this.feeServiceItems,
              }),
            );
          }

          if (this.isOpenFromST) {
            const data: any = {
              ...res,
              actionType: 'update',
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
              cardGroupIndex: this.cardGroupIndex,
            };
            this.dataService.sendData(this.dataService.typePassData('st-card-group-item', data));
          }

          // open update canned service dialog
          if (Object.values(this.updatedInputStates).includes(true)) {
            if (this.updatedInputStates.cost && !this.updatedInputStates.description && !this.updatedInputStates.count && !this.updatedInputStates.isTaxable) {
              this.updateCannedService(res);
            } else {
              tire = {
                ...res,
                costRate: tire.cost,
              };
              this.openUpdateCannedServicesDialog({ ...tire, _id: this.tireId });
            }
          }
        },
        (err) => {
          if (err === 'exists_in_order') {
            this.isProcessing = false;
            this.handleSubmit(false);
          } else {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          }
          // this.isProcessing = false;
          // this.helperService.showToaster('error', err);
        },
      );
    }
  }

  async updateCannedService(data) {
    const cannedServices = await this.httpService.getCannedServicesByItem(this.tireId);

    if (cannedServices.length === 0) {
      return;
    }
    const payload = <any>{
      services: cannedServices.map((c: any) => {
        return {
          _id: c._id,
          itemType: c.itemType,
        };
      }),
      itemId: this.tireId,
      isPassThroughTax: data.isPassThroughTax,
    };
    payload.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
    payload.price = this.formatService.setDynamicCostAndPrice(data, 'price');
    await this.httpService.updateCannedServicesByItem(payload);
  }

  /**
   * Get canned services for the provided item
   */
  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);

      if (cannedServices.length === 0) return;
      data.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
      data.price = this.formatService.setDynamicCostAndPrice(data, 'price');
      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  onUpdateSupplier(data) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.suppliers.length; i++) {
          if (this.suppliers[i]._id === res._id) {
            this.suppliers[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.vendorsSuggestion.length; i++) {
          if (this.vendorsSuggestion[i]._id === res._id) {
            this.vendorsSuggestion[i].name = data.name;
            break;
          }
        }

        if (this.tire.vendor && this.tire.vendor._id === res._id) {
          this.tire.vendor.name = data.name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleCreateTire(tires: any[]) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    const item = this.helperService.deepCopy(tires);
    if (this.isOpenFromPO || (this.orderServiceId && tires.length)) {
      if (this.isSalesCodeEnabled && !this.canEditClassifications) {
        tires[0].salesCode = this.defaultSalesCode;
      }
    }

    // if(this.isMagicFocus) {
    //   tires = {
    //     ...tires,
    //     ...this.tooltipData
    //   }
    // }
    this.httpService.createTires(tires).then(
      (res: any) => {
        this.handleCloseModal();
        this.dataService.sendData(this.dataService.typePassData('tire-list', {}));
        this.helperService.showToaster('success', 'Tire created');

        if (this.isOpenFromPO || this.orderServiceId) {
          if (this.isSalesCodeEnabled && !this.canEditClassifications) {
            res.salesCode = item?.salesCode;
          }
        }

        if (this.isSalesCodeEnabled) {
          this.logPXGaingSightCustomEvent(res);
        }

        if (this.isOpenFromPO) {
          if (res && res.length > 0) {
            res.forEach((item: any) => {
              item.actionType = 'create';
              if (!item.itemId) {
                item.itemId = item._id;
              }
            });
          }
          this.dataService.sendData(
            this.dataService.typePassData('po-service-item', {
              ...res,
              items: res,
              actionType: 'create',
              poDetails: this.poDetails,
              serviceId: this.orderServiceId,
              index: this.orderServiceItemIndex,
              feeServiceItems: this.feeServiceItems,
            }),
          );
        } else if (this.orderServiceId) {
          let type: string = res?.type;
          let isWarrantyEligible: boolean = res?.isWarrantyEligible || false;
          if (Array.isArray(res) && res?.length) {
            type = res[0]?.type;
            isWarrantyEligible = res[0]?.isWarrantyEligible;
          }
          if (this.dataService.isPartWarrantiesEnabled && type === 'tire' && isWarrantyEligible) {
            let item = res;
            if (Array.isArray(res) && res?.length) {
              item = res[0];
            }
            this.handlePartWarrantiesItem(item, 'create');
          } else {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                items: res,
                serviceId: this.orderServiceId,
                feeServiceItems: this.feeServiceItems,
              }),
            );
          }
        } else if (this.openFrom === 'cannedService') {
          this.dataService.sendData(this.dataService.typePassData('canned-service-item', { items: res, actionType: 'create' }));
        } else if (this.openFrom == 'inventoryAdd') {
          if (this.tire.location && this.tire.location.locationId) {
            res.locations = [{ ...this.tire.location }];
          }

          this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...((res && res[0]) || {}) }));
        } else {
          this.dataService.sendData(this.dataService.typePassData('catalogue-item', { ...((res && res[0]) || {}), actionType: 'create' }));
        }

        this.isProcessing = false;
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleCreateSupplier(data: any) {
    if (!data.isForFurtureUse) {
      this.suppliers.push(data);
      this.vendorsSuggestion.push(data);
    } else {
      this.httpService.createSupplier(data).then(
        (supplier: any) => {
          if (supplier) {
            this.helperService.showToaster('success', 'Vendor created');
            this.suppliers.push(supplier);
            this.vendorsSuggestion.push(supplier);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err.messages);
        },
      );
    }
  }

  removeHazmatFee({ sizeIndex, feeIndex }) {
    sizeIndex = 0;
    if (this.isPassThroughTaxEnable) {
      const fee = this.tire.sizes[sizeIndex].hazmatFeeArray[feeIndex];
      const FETIndex: boolean = fee?.isPassThroughFet;
      if (this.tire.sizes[sizeIndex].fetValue > 0 && FETIndex) {
        const message: string = 'By deleting FET fee. FET would became $0.00. Are you sure you want to remove it';
        this.openConfirmationPrompt(feeIndex, sizeIndex, message);
        return;
      }
    }
    this.tire.sizes[sizeIndex].hazmatFeeArray.splice(feeIndex, 1);
    this.feeServiceItems = this.tire.sizes[0].hazmatFeeArray;
  }

  openConfirmationPrompt(feeIndex: number, sizeIndex: number, message: string) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'FET fee is associated',
        message: message,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close?.isSuccess) {
        this.tire.sizes[sizeIndex].hazmatFeeArray.splice(feeIndex, 1);
        if (this.tire.sizes[sizeIndex]?.fetValue) {
          this.tire.sizes[sizeIndex].fetValue = 0;
        }
      }
      onClose.unsubscribe();
    });
  }

  addAnotherFee() {
    this.tire.sizes[0].hazmatFeeArray.push(this.helperService.deepCopy(this.hazmatFeeObject));
    this.feeServiceItems = this.tire.sizes[0].hazmatFeeArray;
  }

  onROSelect(item, feeIndex) {
    this.tire.sizes[0].hazmatFeeArray[feeIndex] = item;
    this.feeServiceItems = this.tire.sizes[0].hazmatFeeArray;
    this.itemResults.map((searchList, i) => {
      this.itemResults[i] = searchList.filter((itm) => itm._id !== item._id);
    });
  }

  getFETRatefromTireConnect(sizeIndex: number) {
    sizeIndex = 0;
    if (!this.tire?.sizes[sizeIndex]?.code) {
      return;
    }
    const dataObj = {
      partNumbers: [this.tire.sizes[sizeIndex]?.code],
      season: null,
      categories: [],
      suppliers: [],
      offers: [],
    };
    this.showLoaderTireconnect = true;
    this.httpService
      .getFETFromTireConnect(dataObj)
      .then(
        (res: any) => {
          if (res?.data?.tires?.length) {
            this.tire.sizes[sizeIndex].tireconnectFetValue = res?.data?.tires[0].fet || 0;
            this.tire.sizes[sizeIndex].fetValue = res?.data?.tires[0].fet || 0;
            if (this.tire.sizes[sizeIndex].fetValue) {
              this.getFetFee(sizeIndex);
            }

          } else {
            this.helperService.showToaster('error', res?.notice);
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.showLoaderTireconnect = false;
      });
  }

  searchSuggestion(event, i) {
    const index = i;
    this.isSearching = true;
    this.httpService
      .getItems({
        limit: 100,
        search: trim(event),
        type: 'hazmatFee',
      })
      .then(
        (data: any) => {
          this.itemResults[index] = [];
          if (data.records) {
            if (this.tire.sizes[0].hazmatFeeArray.length > 0) {
              this.itemResults[index] = data.records.filter(({ _id, title }) => !this.tire.sizes[0].hazmatFeeArray.find((fee: any) => fee && fee._id === _id && fee.title === title));
            } else {
              this.itemResults[index] = data.records;
            }
          }
        },
        (err) => {
          this.isSearching = false;
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categoriesSuggestionsResults];
    }
    this.isShowError = false;
  }

  handleCreateBrand(data: any, isAutoCreate: boolean = false) {
    if (this.isNewCategoriesEnabled) {

      const item = {
        itemType: 'tire',
        categoryName: data.name || data.brandName,
      };

      if (!data.isForFurtureUse) {
        this.brands.push(data);
      } else {
        this.httpService.createBrand(item).then(
          (brand: any) => {
            if (brand) {
              this.helperService.showToaster('success', 'Brand created');
              const newBrand = {
                brandName: brand.category.categoryName,
                name: brand.category.categoryName,
                brandID: brand.category.categoryId,
              };
              this.brands.push(newBrand);
              this.tire.brand = brand;
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
      }

    } else {
      data.type = config.tags.tire;

      if (!data.isForFurtureUse) {
        this.brands.push(data);
        this.tagsSuggestion.push(data);
      } else {
        this.httpService.createTag(data).then(
          (brand: any) => {
            if (brand) {
              if (!isAutoCreate) {
                this.helperService.showToaster('success', 'Brand created');
              }
              this.brands.push(brand);
              this.tire.brand = brand;
              this.tagsSuggestion.push(brand);
              if (isAutoCreate) {
                this.setTireTitleCrtiteria('brand');
              }
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
      }
    }

  }

  saveCategory(category) {
    this.createCategory({
      categoryName: category.name || category.categoryName,
      itemType: 'tire',
    });
  }

  createCategory(data: any) {
    if (this.isNewCategoriesEnabled) {
      this.httpService.createCategory(data).then(
        (category: any) => {
          if (category) {
            this.helperService.showToaster('success', messages.categoryCreated);
            this.categoriesSuggestionsResults.push(category?.category);
            this.tire.category = category?.category;
            this.categoryResults = [...this.categoriesSuggestionsResults];
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    } else {
      this.httpService.createTag({
        name: data?.categoryName,
        type: this.categoryType ? this.categoryType : config.tags.tire,
        color: '',
      }).then(
        (category: any) => {
          if (category) {
            this.helperService.showToaster('success', messages.categoryCreated);
            const obj = {
              ...category,
              categoryName: category?.name,
              categoryId: category?._id
            }
            this.categoriesSuggestionsResults.push(obj);
            this.tire.category = obj;
            this.categoryResults = [...this.categoriesSuggestionsResults];
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }

  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categoriesSuggestionsResults.filter(({ categoryName }) => {
        if (categoryName && new RegExp(`${query}`, 'gi').test(categoryName)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categoriesSuggestionsResults];
    } else if (type === 'category') {
      this.tire.category = {}
    }
  }

  searchCategorySuggestion = debounce((event, pageIndex: number = 0, isSaveCategory = false) => {
    if (!event) return;
    this.partsTechPageIndex = pageIndex;
    this.partstechResults = [];
    // this.selectedValue = event;
    const query: any = {
      itemType: 'tire',
      limit: this.limit,
      skip: 0,
    };

    if (event) query.searchTerm = encodeURI(event);
    this.isDataLoading = true;
    this.httpService.getSearchPricingCategories(query).then((res: any) => {
      if (res?.categories[0] && res?.categories[0].metaData) {
        this.totalRecords = res?.categories[0].metaData.totalRecords;
      }
      if (res?.categories[0] && res?.categories[0].records) {
        res?.categories[0].records?.forEach((element) => {
          if (element.category) {
            this.partstechResults.push(element.category);
          }
        });
      }
      this.isDataLoading = false;
      if (isSaveCategory) {
        this.tire.category = this.partstechResults[0];
      }
    });
  }, 1000);

  onClearCategorySuggestion(type) {
    this.tire.category = {
      name: '',
      categoryName: '',
    };
  }

  handleSearchValue(value) {
    this.tire.category = {
      name: value,
      categoryName: value,
    };
  }

  // onCategorySelect(event, isFromCatSearch = true) {
  //   this.tire.category = {
  //     categoryId: '',
  //     name: '',
  //   };
  //   this.customCategory._id = event.level3 ? event.level3._id : event.level2 ? event.level2._id : event.level1._id;
  //   if (event.level1) {
  //     this.tire.category.name = event.level1.categoryName;
  //     this.tire.category.categoryId = event.level1.categoryId;
  //     this.customCategory.category = event.level1;
  //   }
  //   this.tire.category._id = this.tire.category.categoryId;
  //   this.tire.category.customCategory = this.customCategory;
  // }

  // categoryDropdownSelect(type, event) {
  //   if (type === 'category' && event.categoryId) {
  //     delete this.customCategory.subCategory;
  //     delete this.customCategory.subSubCategory;
  //     this.onCategorySelect({ level1: event }, false);
  //   }
  //   this.dataService.sendData(this.dataService.typePassData('category-selected', {}));
  // }

  getAllCategories() {
    const query: any = { itemType: 'tire' };
    this.loader.category = true;
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        res.categories.forEach((element) => (element.categoryId = element._id));
        this.categoryResults = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(res.categories);
      })
      .finally(() => {
        this.loader.category = false;
      });
  }

  getNewCategories(searchTerm = '', isSaveCategory = false) {
    const query: any = {
      itemType: 'tire',
      limit: this.limit,
      skip: 0,
    };
    query.searchTerm = searchTerm;
    this.httpService.getSearchPricingCategories(query).then((res: any) => {
      if (res?.categories[0] && res?.categories[0].metaData) {
        this.totalRecords = res?.categories[0].metaData.totalRecords;
      }
      if (res?.categories[0] && res?.categories[0].records) {
        res?.categories[0].records?.forEach((element) => {
          if (element.category) {
            this.partstechResults.push(element.category);
          }
        });
        if (isSaveCategory) {
          this.tire.category = this.partstechResults[0];
        }
      }
    });
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && !this.isOpenFromRO) {
      return;
    }
    const data = {
      item: this.tire,
      openFrom: 'new-tire-modal',
    };
    data.item.title = data.item?.name || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'new-tire-modal', null, null, data));
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.tire.salesCode, this.tire.category);
  }

  search(query: string) {
    if (query) {
      const conf = {
        limit: 200,
        offset: 0,
        sortField: 'title',
        sortOrder: 1,
        search: trim(query),
        activeStatus: true || '',
      };

      this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
        (location: any) => {
          this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
            locationId: _id,
            name: title,
            warehouseId: warehouseId,
          }));
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      );
    } else {
      this.getLocations();
    }
  }

  getLocations(limit = 200, offset = this.tableConfig.offset, sortField: any = this.tableConfig.sortField, sortOrder = this.tableConfig.sortOrder, activeStatus = true, search = '') {
    const conf = {
      limit,
      offset,
      sortField,
      sortOrder,
      search,
      activeStatus,
    };

    this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
      (location: any) => {
        this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
          locationId: _id,
          name: title,
          warehouseId: warehouseId,
        }));
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getIconColor(): string {
    let iconColor: string = 'font-gray-65';
    if (this.tire.sizes[0]?.fetValue && this.tire.sizes[0]?.tireExternalId) {
      iconColor = 'font-primary';
    } else if (this.tire.sizes[0]?.tireExternalId) {
      iconColor = 'font-warning-800';
    } else {
      iconColor = 'font-gray-65';
    }

    return iconColor;
  }

  isOnlyZeros = (str: string): boolean => {
    return /^0+$/.test(str);
  };

  handleSizeSelectQTQ(key: string, valueText: any) {
    let value = this.helperService.trimString(valueText);
    const length = value?.length || 0;

    if (key === 'tireWidth') {
      // Ignore values containing only zeros
      if (this.isOnlyZeros(value)) {
        // value = '';
      }

      // Set tireWidth and clear related errors
      this.tire.tireWidth = value;
      this.errors.tireWidth = '';

      // Automatically focus on 'tireProfile' if 3 characters are entered
      if (length > 2) {
        this.handleFocus('tireProfile');
      }
    } else if (key === 'tireProfile') {
      // Ignore values containing only zeros
      if (this.isOnlyZeros(value)) {
        // value = '';
      }

      this.tire.tireProfile = length > 2 ? value.includes('.') ? value : value.substring(0, 3) : value;
      this.errors.tireProfile = '';

      // Automatically focus on 'tireSize' if 2 or more characters are entered
      if (length >= 2) {
        this.handleFocus('tireSize');
      }
    } else if (key === 'tireSize') {
      // Ignore values containing only zeros
      if (this.isOnlyZeros(value)) {
        // value = '';
      }

      // Set tireSize and clear related errors
      this.tire.tireSize = value;
      this.errors.tireSize = '';
    }

    if (key === 'tireWidth' || key === 'tireProfile' || key === 'tireSize') {
      if (this.isMagicFocus) {
        this.isMagicFocus = false;
      }
    }

    this.tire.sizes[0].size = `${this.tire?.tireWidth || ''}${this.tire?.tireProfile || ''}${this.tire?.tireSize || ''}`;

    this.setTireTitleCrtiteria('size');
    this.errors.title = '';
  }


  onTabSelect(event) {
    this.selectedTab = event;
    this.activeIndex = null;
    if (this.selectedTab === 1) {
      this.getLogs();
    }
  }

  isManuallyAdded() {
    return (this.isAddedManually = Number(this.tire?.sizes[0]?.price) !== Number(this.calculatedAmount));
  }

  onUpdateItem(item, type: string) {
    if (this.isNewCategoriesEnabled) {
      const itemData = {
        itemType: 'tire',
        categoryId: item.categoryId || item._id,
        categoryName: item.name || item.categoryName,
      };

      this.httpService.updateCategory(itemData).then(
        (data) => {
          for (let i = 0; i < this.categoriesSuggestionsResults.length; i++) {
            if (this.categoriesSuggestionsResults[i]._id === item._id) {
              this.categoriesSuggestionsResults[i].categoryName = item.name;
              break;
            }
          }

          for (let i = 0; i < this.categoryResults.length; i++) {
            if (this.categoryResults[i]._id === item._id) {
              this.categoryResults[i].categoryName = item.name;
              break;
            }
          }

          for (let i = 0; i < this.brands.length; i++) {
            if (this.brands[i].categoryId === item._id) {
              this.brands[i].name = item.name;
              break;
            }
          }

          // for (let i = 0; i < this.brands.length; i++) {
          //   if (this.brands[i]._id === item._id) {
          //     this.brands[i].name = item.name;
          //     break;
          //   }
          // }

          if (this.tire.brand && this.tire.brand._id === item._id) {
            this.tire.brand.name = item.name;
          }

          if (this.tire.category && this.tire.category._id === item._id) {
            this.tire.category.name = item.name;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    } else {
      const tag = {
        _id: item?.categoryId || item?._id,
        color: item?.color,
        type,
        name: trim(item?.name || item?.categoryName),
      };

      this.httpService.updateTag(tag).then(
        (data) => {
          const name = trim(item?.name || item?.categoryName);
          const _id = item?.categoryId || item?._id
          for (let i = 0; i < this.categoriesSuggestionsResults.length; i++) {
            if (this.categoriesSuggestionsResults[i]._id === _id) {
              this.categoriesSuggestionsResults[i].name = name;
              break;
            }
          }

          for (let i = 0; i < this.brands.length; i++) {
            if (this.brands[i]._id === _id) {
              this.brands[i].name = name;
              if (this.tagsSuggestion[i]._id === _id) {
                this.tagsSuggestion[i].name = name;
              }
              break;
            }

          }

          for (let i = 0; i < this.categoryResults.length; i++) {
            if (this.categoryResults[i]._id === _id) {
              this.categoryResults[i].name = name;
              break;
            }
          }

          if (this.tire.brand && this.tire.brand._id === _id) {
            this.tire.brand.name = name;
          }

          if (this.tire.category && this.tire.category._id === _id) {
            this.tire.category.name = name;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }

  }

  showPartSuggestionContainer(type) {
    if (!this.isTireConnectConnected) return;

    if (type === 'magic') {
      if (this.tire.tireExternalId) {
        this.isProcessingResults = true;
        this.getPartstechSearch(this.tire.tireExternalId);
      }
    }

    if (type === 'clear') this.resetAutofillFields();
  }

  setAutofillFields(partstechSuggestion, type) {
    this.selectedType = type;

    if (type === 'select') {
      this.isMagicFocus = false;
    } else if (type === 'hover') {
      this.isMagicFocus = true;
    }
    this.setAutofillData(partstechSuggestion);
  }

  resetAutofillFields() {
    this.tire.brand = {};
    this.tire.model = '';
    this.tire.tireWidth = '';
    this.tire.tireSize = '';
    this.tire.tireProfile = '';
    this.tire.sizes[0].title = '';
    this.tire.sizes[0].size = '';
    this.tire.seasonality = '';
    this.tire.category = {};
    this.tire.tireType = {};
    this.isMagicFocus = false;
    this.isProcessingResults = false;
    this.isShowPartSuggestions = false;
    this.partstechSuggestions = [];
    this.partSearchResults = [];
    this.tooltipData = { brand: '', cost: '', price: '', date: '' };
    this.tooltip = '';
    this.tire.loadIndex = '';
    this.tire.loadIndexDual = '';
    this.tire.speedRating = '';
    this.tire.loadRange = '';
    this.tire.sideWallStyle = '';
    this.tire.utqg = '';
    this.tire.mileageRating = '';
  }

  clearAutofillFields() {
    this.tire.brand = {};
    this.tire.model = '';
    this.tire.tireWidth = '';
    this.tire.tireSize = '';
    this.tire.tireProfile = '';
    this.tire.sizes[0].title = '';
    this.tire.sizes[0].size = '';
    this.tire.seasonality = '';
    this.tire.category = {};
    this.tire.tireType = {};
    this.isMagicFocus = true;
    this.isProcessingResults = false;
    this.tire.loadIndex = '';
    this.tire.loadIndexDual = '';
    this.tire.speedRating = '';
    this.tire.loadRange = '';
    this.tire.sideWallStyle = '';
    this.tire.utqg = '';
    this.tire.mileageRating = '';
    this.setAutofillData(this.partSearchResults[0]);
  }

  setClickOutSideListeners() {
    this.dataService
      .getClickEvent()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((target) => {
        if (this.isShowPartSuggestions && !this.focus.tireExternalId) {
          this.isShowPartSuggestions = false;
          this.focus.tireExternalId = false;
        }
      });
  }

  getPartstechSearch = debounce((partNumber?) => {
    this.partSearchResults = [];
    this.partstechSuggestions = [];

    const data = { partNumbers: partNumber };
    this.httpService.getTireconnectSearch(data).then((res: any) => {
      if (res.data && res.data.tires.length >= 0) {
        this.partSearchResults = res.data.tires;

        if (this.partSearchResults?.length && this.partSearchResults?.length === 1) {
          this.setAutofillData(res.data.tires[0]);
          this.isShowPartSuggestions = !this.isShowPartSuggestions;
          this.isMagicFocus = true;
        }

        if (this.partSearchResults?.length && this.partSearchResults.length > 1) {
          this.partstechSuggestions = this.partSearchResults;
          this.setAutofillFields(this.partstechSuggestions[0], 'hover');
          this.isShowPartSuggestions = !this.isShowPartSuggestions;
        }

        // if (this.part.category?.categoryName) {
        //   this.checkPricingBackwardCompatibility();
        // }
        this.isProcessingResults = false;
      } else {
        this.partSearchResults = [];
        this.clearAutofillFields();
        this.isProcessingResults = false;
      }
    });
  }, 800);

  async setAutofillData(partSearchResults) {
    const { brand, model, size_w, size_h, size_r, season, tire_type, category, category_id, tread_depth, load_range, speed_rating, load_index, cost, price, load_index_dual, side_wall_style, mileage_rating, utqg, fet } = partSearchResults;
    //if(this.dataService.isUseOnlinePricing && this.dataService.isPricingManagementEnable) {
    this.tooltipData = {
      isMagicFill: true,
      magicFillBrand: brand,
      magicFillCost: cost,
      magicFillPrice: price,
      magicFillDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date().getTime()), datetimeFormat.hhmmaammmdyy)
    }
    this.setTooltipData()
    //}

    let seansonType = '';
    this.tire.partSpecification = {};

    // Autoset brand name
    if (brand) {
      const conf = {
        searchQuery: brand,
        itemType: 'tire',
        codeType: 'brand',
      };

      const res: any = await this.httpService.getPartWarrantiesBrands(conf);
      if (res.categories?.[0]?.records.length) {
        const searchbrand = res.categories?.[0]?.records.filter((b) => {
          if (b.categoryName === brand) {
            return b;
          }
        });
        if (searchbrand.length) {
          this.handleSelect(
            {
              brandName: searchbrand[0].categoryName,
              name: searchbrand[0].categoryName,
              categoryId: searchbrand[0].categoryId,
              brandID: searchbrand[0].categoryId,
              _id: searchbrand[0]._id,
              isDefault: true,
            },
            'brand',
          );
        }
      } else {
        const brandData = {
          itemType: 'tire',
          categoryName: brand,
        };

        this.httpService.createBrand(brandData).then(
          (brand: any) => {
            if (brand) {
              const newBrand = {
                brandName: brand.category.categoryName,
                name: brand.category.categoryName,
                brandID: brand.category.categoryId,
              };
              this.brands.push(newBrand);
              this.tire.brand = brand;
              this.handleSelect(
                {
                  brandName: brand.category.categoryName,
                  name: brand.category.categoryName,
                  categoryId: brand.category.categoryId,
                  brandID: brand.category.categoryId,
                  _id: brand._id,
                  isDefault: true,
                },
                'brand',
              );
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
      }
    }

    // Autoset Tyre category
    if (category) {
      const categoryData = this.categoryResults.filter((cat) => {
        if (cat.categoryName == category) {
          return cat;
        }
      });

      if (categoryData.length) {
        this.handleSelect(categoryData[0], 'category');
      } else {
        if (this.isNewCategoriesEnabled) {
          const categoryData = {
            categoryName: category,
            itemType: 'tire',
          };

          this.httpService.createCategory(categoryData).then(
            (category: any) => {
              if (category) {
                this.categoriesSuggestionsResults.push(category?.category);
                this.tire.category = category?.category;
                this.categoryResults = [...this.categoriesSuggestionsResults];
                this.handleSelect({ categoryId: category?.category?.categoryId, categoryName: category?.category?.categoryName, _id: category._id }, 'category');
              }
            },
            (err) => {
              this.helperService.showToaster('error', err);
            },
          );
        } else {
          this.saveCategory({ name: category });
        }

      }
    }

    // Autoset Tyre type
    const tyreType = this.tireTypeSuggestion.filter((tyreType) => {
      if (tyreType.name == tire_type) {
        return tyreType;
      }
    });

    if (tyreType.length) {
      this.handleSelect(tyreType[0], 'tireType');
    } else {
      const tyreType = {
        name: tire_type,
      };
      this.handleSelect(tyreType, 'tireType');
    }

    if (season) {
      if (new RegExp('All Season', 'i').test(season)) seansonType = 'all';
      else if (new RegExp('all season', 'i').test(season)) seansonType = 'all';
      else if (new RegExp('winter', 'i').test(season)) seansonType = 'winter';
      else if (new RegExp('summer', 'i').test(season)) seansonType = 'summer';
      else if (new RegExp('allWeather', 'i').test(season)) seansonType = 'allWeather';
    }

    if (cost) {
      if (this.isUseOnlinePricing) {
        this.handleSizeChange('cost', cost);
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
        this.tire.sizes[0].costType = this.costOptions[0].value;
      } else if (this.tire.sizes[0].cost === 0 || this.tire.sizes[0].cost === '') {
        this.isFocusPartTire = (this.tire.sizes[0].cost === 0 || this.tire.sizes[0].cost === '') ? true : false;
        this.handleSizeChange('cost', cost);
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
        this.tire.sizes[0].costType = this.costOptions[0].value;
      }
    }

    if (price) {
      if (this.isUseOnlinePricing) {
        this.handleSizeChange('price', price);
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
      } else if (this.tire.sizes[0].price === 0 || this.tire.sizes[0].price === '') {
        this.isFocusPartTire = (this.tire.sizes[0].price === 0 || this.tire.sizes[0].price === '') ? true : false;
        this.handleSizeChange('price', price);
        this.tire.sizes[0].pricingMatrix = this.noMatrix[0];
      }
    }

    this.handleChange(model, 'model');
    this.handleSizeSelectQTQ('tireWidth', size_w);
    this.handleSizeSelectQTQ('tireProfile', size_h);
    this.handleSizeSelectQTQ('tireSize', size_r);
    this.handleChange(seansonType, 'seasonality');

    // dont focus while using magic fill
    this.focus = {
      ...this.focus,
      tireWidth: false,
      tireProfile: false,
      tireSize: false
    }

    this.tire.partSpecification = {
      loadIndex: load_index,
      speedRating: speed_rating,
      loadRange: load_range,
      treadDepth: tread_depth,
    };


    this.tire = {
      ...this.tire,
      loadIndex: load_index || '',
      loadIndexDual: load_index_dual || '',
      speedRating: speed_rating || '',
      loadRange: load_range || '',
      sideWallStyle: side_wall_style || '',
      utqg: utqg ? this.parseutqg(utqg) : '',
      mileageRating: this.processMiles(
        mileage_rating
        || ''),
      fet
    }

    this.isMagicFocus = true;

    if (this.selectedType === 'select') {
      this.isMagicFocus = false;
    }
  }

  navigateToWarrantySection() {
    this.helperService.openPageInNewExistingTab('/catalog/warranties', '/catalog/warranties');
  }

  getWarrantyByItemSpec() {
    if (!this.tire?.tireType?.tireTypeId || !this.isPartWarrantiesEnabled) {
      return;
    }
    this.isFetchingWarranty = true;
    const data = {
      partTypeId: this.tire?.tireType?.tireTypeId,
      itemType: 'tire',
    };
    this.httpService
      .getWarrantyByItemSpec(data)
      .then(
        (res: any) => {
          if (res?._id) {
            this.tire.warranty = {
              warrantySettingId: res._id,
              title: res.title,
            };
            this.tire.isWarrantyEligible = true;
          } else {
            this.tire.isWarrantyEligible = false;
            this.tire.warranty = {};
            this.helperService.showToaster('error', 'No matching Warranty found.');
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isFetchingWarranty = false;
      });
  }

  handlePartWarrantiesItem(item: any, actionType: string) {
    if (!item.warrantyTags) {
      item.warrantyTags = [];
    }
    const tagIndex = findIndex(item.warrantyTags, { tagType: 'partWarranties' });
    if (tagIndex < 0) {
      item.warrantyTags.push({
        color: '#3D7EAD',
        name: 'Warranty',
        tagType: 'partWarranties',
        tooltip: `Warranty`,
      });
    }

    item.warranty = {
      warrantySettingId: item?.warranty?.warrantySettingId,
      title: item?.warranty?.title,
    };

    this.openWarrantyEligibleDialog(
      {
        itemTitle: item?.title || '',
        itemId: item._id,
        partNumber: item?.code || '',
        customerId: this.customerId,
        vehicleId: this.vehicleId,
        type: item?.type
      },
      item,
      actionType,
    );
  }

  openWarrantyEligibleDialog(serviceItemFields: any, item: any, actionType: string) {
    const ref = this.dialogService.open(WarrantyEligibleDialogComponent, {
      width: '30%',
      styleClass: 'add-dialog warranty-eligible-dialog',
      showHeader: false,
      data: {
        ...serviceItemFields,
        invoicedRO: this.invoicedRO,
        isWarrantyNumberAddonEnabled: this.dataService.isWarrantyNumberAddonEnabled,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      const index = findIndex(item.warrantyTags, { tagType: 'partWarranties' });
      if (isSuccess && data) {
        if (item?.warranty) {
          item.warranty.type = data?.warrantyType;
          item.warranty.replacementType = data?.partWarrantyType;
        }
        if (data?.warrantyType === 'first-time') {
          if (index > -1) {
            item.warrantyTags[index].name = 'Warranty (First Install)';
            item.warrantyTags[index].tooltip = 'Warranty (First Install)';
          }
        } else if (data?.warrantyType === 'replacement') {
          if (index > -1) {
            item.warrantyTags[index].name = 'Warranty (Replacement)';
            item.warrantyTags[index].tooltip = 'Warranty (Replacement)';
          }

          if (data?.partWarrantyType === 'being-replaced') {
            if (data?.selectedPart?.warrantyNumber) {
              // item.previousWarrantyNumber = data?.selectedPart?.warrantyNumber;
              item.warranty.previousWarrantyNumber = data?.selectedPart?.warrantyNumber;
            }

            if (data?.selectedPart?._id) {
              item.warranty.replacementInvoice = {
                partName: data?.selectedPart?.partName,
                partNumber: data?.selectedPart?.partNumber,
                invoiceDate: data?.selectedPart?.invoiceDate,
                invoiceId: data?.selectedPart?.invoiceId || '',
                invoiceCode: data?.selectedPart?.code,
              };
            }
          } else if (data?.partWarrantyType === 'manually-entered') {
            if (data?.warrantyNumber) {
              item.warranty.previousWarrantyNumber = data?.warrantyNumber;
              item.warranty.replacementInvoice = {
                partName: data?.selectedPart?.partName,
                partNumber: data?.selectedPart?.partNumber,
                invoiceDate: data?.selectedPart?.invoiceDate,
                invoiceCode: data?.selectedPart?.invoiceCode,
              };
            }
          }

          if (data?.isSetCostPriceZero) {
            item.cost = 0;
            item.price = 0;
          }

          // Tires only
          if (item.type === 'tire' && data?.isSetPriceZeroOnly) {
            item.price = 0;
          }
        }
        else {
          item.isWarrantyEligible = false;
          item.warrantyTags.splice(index, 1);
        }
      } else {
        if (index > -1) {
          item.isWarrantyEligible = false;
          item.warranty = {};
          item.warrantyTags.splice(index, 1);
        }
      }

      if (actionType === 'create') {
        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...item,
            actionType: 'create',
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
            feeServiceItems: this.feeServiceItems,
          }),
        );
      } else {
        this.dataService.sendData(
          this.dataService.typePassData('ro-service-item', {
            ...item,
            actionType: 'update',
            isLocal: true,
            serviceId: this.orderServiceId,
            index: this.orderServiceItemIndex,
            isChangeInPriceMatrix: this.isChangeInPriceMatrix,
            whichPricingMatrixUsed: this.whichPricingMatrixUsed,
            isPriceManuallyAdded: this.tire.isPriceManuallyAdded,
            feeServiceItems: this.feeServiceItems,
          }),
        );
      }

      onClose.unsubscribe();
    });
  }

  setTooltipData() {
    if (this.tooltipData.magicFillBrand || this.tooltipData.magicFillCost || this.tooltipData.magicFillPrice) {
      this.tooltip = `Manufacturer Pricing \n`;
      this.tooltip += `Cost: $${this.tooltipData.magicFillCost}  \n`;
      this.tooltip += `Price: $${this.tooltipData.magicFillPrice}  \n`;
      this.tooltip += `Last Updated on ${this.tooltipData.magicFillDate} \n`;
    }
  }

  toggleRowExpansion() {
    this.isExpanded = !this.isExpanded;
  }

  processMiles(data) {
    if (!data) {
      return "";
    }

    if (String(data)?.toLowerCase().includes("miles")) {
      return data.replace(/miles/i, "").trim();
    }

    return data;
  }

  isLocationDisabled() {
    if (this.isForceLocationUpdate) {
      return false;
    } else {
      return (!!this.tireId && this.isOpenFromPO && !this.updateGenericItem)
    }
  }

  openQtyOnEstimateModal() {
    const size = this.tire?.sizes?.[0];
    const name = size?.title || size?.name || size?.titleFR || 'N/A';

    this.dialogService.open(QtyOnEstimateListModalComponent, {
      width: '1150px',
      styleClass: 'add-dialog qty-stock-list-modal',
      showHeader: false,
      data: {
        name,
        itemId: this.tireId,
      },
    });
  }

  resetPricingMatrix() {
    this.tire.sizes[0].pricingMatrix = {};
    this.tire.sizes[0].price = 0;
    this.pricingMatrixResults = [...this.pricings];
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }
}
